import React, { useCallback, useState, lazy, Suspense } from 'react';
import {
  Button,
  TextInput,
  NumberInput,
  Select,
  SelectItem,
  Checkbox,
  DataTable,
  TableRow,
  TableHead,
  TableHeader,
  TableContainer,
  TableCell,
  Table,
  TableBody,
  TableToolbar,
  TableToolbarContent,
} from 'carbon-components-react';

import Collapsible from 'react-collapsible';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { Tooltip as ReactTooltip } from "react-tooltip";


import { safeLoad, getDivHeight, jsonToYaml, updateStyle, updateStyle2, validateField, toggleDescription } from '../../helpers';

const ServerclientIpRulesDeleteModal = lazy(() => import('./serverclient_ip_rulesDeleteModal'));
const ServerclientIpRulesAdd = lazy(() => import('./serverclient_ip_rulesAdd'));
const ServerclientIpRulesEdit = lazy(() => import('./serverclient_ip_rulesEdit'));
const ServerenabledLanguagesDeleteModal = lazy(() => import('./serverenabled_languagesDeleteModal'));
const ServerenabledLanguagesAdd = lazy(() => import('./serverenabled_languagesAdd'));
const ServerenabledLanguagesEdit = lazy(() => import('./serverenabled_languagesEdit'));
const ServerlocalApplicationscredViewerattributesDeleteModal = lazy(() => import('./serverlocal_applicationscred_viewerattributesDeleteModal'));
const ServerlocalApplicationscredViewerattributesAdd = lazy(() => import('./serverlocal_applicationscred_viewerattributesAdd'));
const ServerlocalApplicationscredViewerattributesEdit = lazy(() => import('./serverlocal_applicationscred_viewerattributesEdit'));
const ServerprotocolsDeleteModal = lazy(() => import('./serverprotocolsDeleteModal'));
const ServerprotocolsAdd = lazy(() => import('./serverprotocolsAdd'));
const ServerprotocolsEdit = lazy(() => import('./serverprotocolsEdit'));
const ServerresponseHeadersDeleteModal = lazy(() => import('./serverresponse_headersDeleteModal'));
const ServerresponseHeadersAdd = lazy(() => import('./serverresponse_headersAdd'));
const ServerresponseHeadersEdit = lazy(() => import('./serverresponse_headersEdit'));
const ServersslciphersDeleteModal = lazy(() => import('./serversslciphersDeleteModal'));
const ServersslciphersAdd = lazy(() => import('./serversslciphersAdd'));
const ServersslciphersEdit = lazy(() => import('./serversslciphersEdit'));
const ServersslfrontEndcertificateDeleteModal = lazy(() => import('./serversslfront_endcertificateDeleteModal'));
const ServersslfrontEndcertificateAdd = lazy(() => import('./serversslfront_endcertificateAdd'));
const ServersslfrontEndcertificateEdit = lazy(() => import('./serversslfront_endcertificateEdit'));
const ServersslfrontEndsniDeleteModal = lazy(() => import('./serversslfront_endsniDeleteModal'));
const ServersslfrontEndsniAdd = lazy(() => import('./serversslfront_endsniAdd'));
const ServersslfrontEndsniEdit = lazy(() => import('./serversslfront_endsniEdit'));
const ServersslfrontEndsnicertificateDeleteModal = lazy(() => import('./serversslfront_endsnicertificateDeleteModal'));
const ServersslfrontEndsnicertificateAdd = lazy(() => import('./serversslfront_endsnicertificateAdd'));
const ServersslfrontEndsnicertificateEdit = lazy(() => import('./serversslfront_endsnicertificateEdit'));
const ServerssltrustCertificatesDeleteModal = lazy(() => import('./serverssltrust_certificatesDeleteModal'));
const ServerssltrustCertificatesAdd = lazy(() => import('./serverssltrust_certificatesAdd'));
const ServerssltrustCertificatesEdit = lazy(() => import('./serverssltrust_certificatesEdit'));


const handleChange = () =>{
    var yamlText = window.iagyaml;

    var json = {};

    if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
    }

    var newElem = {};
    newElem["content_security_policy"] = document.getElementById("server_content_security_policy_id").value;
    var newcredential_service_cache = {};
    newcredential_service_cache["cache_enabled"] = document.getElementById("server_credential_service_cache_cache_enabled_id").checked.toString();
    newcredential_service_cache["cache_size"] = document.getElementById("server_credential_service_cache_cache_size_id").value;
    newcredential_service_cache["entry_idle_timeout"] = document.getElementById("server_credential_service_cache_entry_idle_timeout_id").value;
    newcredential_service_cache["entry_lifetime"] = document.getElementById("server_credential_service_cache_entry_lifetime_id").value;
    newcredential_service_cache["login_clear_user"] = document.getElementById("server_credential_service_cache_login_clear_user_id").checked.toString();
    newElem["credential_service_cache"] = newcredential_service_cache;
    var newerror_pages = {};
    if(document.getElementById("server_error_pages_content_id").value.endsWith(":") !== true) {
    newerror_pages["content"] = document.getElementById("server_error_pages_content_id").value;
    }
    newerror_pages["type"] = document.getElementById("server_error_pages_type_id").value;
    newElem["error_pages"] = newerror_pages;
    var newfailover = {};
    if(document.getElementById("server_failover_cookie_name_id").value.endsWith(":") !== true) {
    newfailover["cookie_name"] = document.getElementById("server_failover_cookie_name_id").value;
    }
    newfailover["domain_cookie"] = document.getElementById("server_failover_domain_cookie_id").checked.toString();
    if(document.getElementById("server_failover_key_id").value.endsWith(":") !== true) {
    newfailover["key"] = document.getElementById("server_failover_key_id").value;
    }
    newElem["failover"] = newfailover;
    newElem["http2"] = document.getElementById("server_http2_id").checked.toString();
    var newlocal_applications = {};
    var newazn_decision = {};
    newazn_decision["max_cache_lifetime"] = document.getElementById("server_local_applications_azn_decision_max_cache_lifetime_id").value;
    newazn_decision["max_cache_size"] = document.getElementById("server_local_applications_azn_decision_max_cache_size_id").value;
    if(document.getElementById("server_local_applications_azn_decision_path_segment_id").value.endsWith(":") !== true) {
    newazn_decision["path_segment"] = document.getElementById("server_local_applications_azn_decision_path_segment_id").value;
    }
    newlocal_applications["azn_decision"] = newazn_decision;
    var newcred_viewer = {};
    newcred_viewer["enable_html"] = document.getElementById("server_local_applications_cred_viewer_enable_html_id").checked.toString();
    if(document.getElementById("server_local_applications_cred_viewer_path_segment_id").value.endsWith(":") !== true) {
    newcred_viewer["path_segment"] = document.getElementById("server_local_applications_cred_viewer_path_segment_id").value;
    }
    newcred_viewer["attributes"] = server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes;
    newlocal_applications["cred_viewer"] = newcred_viewer;
    var newjwks = {};
    if(document.getElementById("server_local_applications_jwks_path_segment_id").value.endsWith(":") !== true) {
    newjwks["path_segment"] = document.getElementById("server_local_applications_jwks_path_segment_id").value;
    }
    newlocal_applications["jwks"] = newjwks;
    newlocal_applications["attributes"] = server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes;
    newElem["local_applications"] = newlocal_applications;
    var newlocal_pages = {};
    if(document.getElementById("server_local_pages_content_id").value.endsWith(":") !== true) {
    newlocal_pages["content"] = document.getElementById("server_local_pages_content_id").value;
    }
    newlocal_pages["type"] = document.getElementById("server_local_pages_type_id").value;
    newElem["local_pages"] = newlocal_pages;
    var newmanagement_pages = {};
    if(document.getElementById("server_management_pages_content_id").value.endsWith(":") !== true) {
    newmanagement_pages["content"] = document.getElementById("server_management_pages_content_id").value;
    }
    newmanagement_pages["type"] = document.getElementById("server_management_pages_type_id").value;
    newElem["management_pages"] = newmanagement_pages;
    var newpublic_assets = {};
    if(document.getElementById("server_public_assets_content_id").value.endsWith(":") !== true) {
    newpublic_assets["content"] = document.getElementById("server_public_assets_content_id").value;
    }
    if(document.getElementById("server_public_assets_path_segment_id").value.endsWith(":") !== true) {
    newpublic_assets["path_segment"] = document.getElementById("server_public_assets_path_segment_id").value;
    }
    newpublic_assets["type"] = document.getElementById("server_public_assets_type_id").value;
    newElem["public_assets"] = newpublic_assets;
    var newrate_limiting = {};
    newrate_limiting["cache_size"] = document.getElementById("server_rate_limiting_cache_size_id").value;
    var newredis = {};
    if(document.getElementById("server_rate_limiting_redis_collection_name_id").value.endsWith(":") !== true) {
    newredis["collection_name"] = document.getElementById("server_rate_limiting_redis_collection_name_id").value;
    }
    newredis["sync_window"] = document.getElementById("server_rate_limiting_redis_sync_window_id").value;
    newrate_limiting["redis"] = newredis;
    newrate_limiting["response_headers"] = document.getElementById("server_rate_limiting_response_headers_id").checked.toString();
    newElem["rate_limiting"] = newrate_limiting;
    var newsession = {};
    if(document.getElementById("server_session_cookie_name_id").value.endsWith(":") !== true) {
    newsession["cookie_name"] = document.getElementById("server_session_cookie_name_id").value;
    }
    newsession["inactive_timeout"] = document.getElementById("server_session_inactive_timeout_id").value;
    newsession["max_sessions"] = document.getElementById("server_session_max_sessions_id").value;
    newsession["permit_user_switching"] = document.getElementById("server_session_permit_user_switching_id").checked.toString();
    var newreauth = {};
    newreauth["login_time_window"] = document.getElementById("server_session_reauth_login_time_window_id").value;
    newsession["reauth"] = newreauth;
    var newredis = {};
    newredis["client_list_cache_lifetime"] = document.getElementById("server_session_redis_client_list_cache_lifetime_id").value;
    var newconcurrent_sessions = {};
    newconcurrent_sessions["enabled"] = document.getElementById("server_session_redis_concurrent_sessions_enabled_id").checked.toString();
    newconcurrent_sessions["max_user_sessions"] = document.getElementById("server_session_redis_concurrent_sessions_max_user_sessions_id").value;
    newconcurrent_sessions["prompt_for_displacement"] = document.getElementById("server_session_redis_concurrent_sessions_prompt_for_displacement_id").checked.toString();
    if(document.getElementById("server_session_redis_concurrent_sessions_user_identity_attribute_name_id").value.endsWith(":") !== true) {
    newconcurrent_sessions["user_identity_attribute_name"] = document.getElementById("server_session_redis_concurrent_sessions_user_identity_attribute_name_id").value;
    }
    newredis["concurrent_sessions"] = newconcurrent_sessions;
    newredis["enabled"] = document.getElementById("server_session_redis_enabled_id").checked.toString();
    newsession["redis"] = newredis;
    newsession["timeout"] = document.getElementById("server_session_timeout_id").value;
    newElem["session"] = newsession;
    var newssl = {};
    var newapplications = {};
    newapplications["tlsv10"] = document.getElementById("server_ssl_applications_tlsv10_id").checked.toString();
    newapplications["tlsv11"] = document.getElementById("server_ssl_applications_tlsv11_id").checked.toString();
    newapplications["tlsv12"] = document.getElementById("server_ssl_applications_tlsv12_id").checked.toString();
    newapplications["tlsv13"] = document.getElementById("server_ssl_applications_tlsv13_id").checked.toString();
    newssl["applications"] = newapplications;
    var newfront_end = {};
    newfront_end["tlsv10"] = document.getElementById("server_ssl_front_end_tlsv10_id").checked.toString();
    newfront_end["tlsv11"] = document.getElementById("server_ssl_front_end_tlsv11_id").checked.toString();
    newfront_end["tlsv12"] = document.getElementById("server_ssl_front_end_tlsv12_id").checked.toString();
    newfront_end["tlsv13"] = document.getElementById("server_ssl_front_end_tlsv13_id").checked.toString();
    newfront_end["sni"] = server_ssl_front_end_snirowData.server_ssl_front_end_sni;
    newfront_end["certificate"] = server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate;
    newssl["front_end"] = newfront_end;
    newssl["sni"] = server_ssl_front_end_snirowData.server_ssl_front_end_sni;
    newssl["certificate"] = server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate;
    newssl["trust_certificates"] = server_ssl_trust_certificatesrowData.server_ssl_trust_certificates;
    newssl["ciphers"] = server_ssl_ciphersrowData.server_ssl_ciphers;
    newElem["ssl"] = newssl;
    var newwebsocket = {};
    var newtimeouts = {};
    var newapplications = {};
    newapplications["read"] = document.getElementById("server_websocket_timeouts_applications_read_id").value;
    newapplications["write"] = document.getElementById("server_websocket_timeouts_applications_write_id").value;
    newtimeouts["applications"] = newapplications;
    var newfront_end = {};
    newfront_end["read"] = document.getElementById("server_websocket_timeouts_front_end_read_id").value;
    newfront_end["write"] = document.getElementById("server_websocket_timeouts_front_end_write_id").value;
    newtimeouts["front_end"] = newfront_end;
    newwebsocket["timeouts"] = newtimeouts;
    var newworker_threads = {};
    newworker_threads["idle"] = document.getElementById("server_websocket_worker_threads_idle_id").value;
    newworker_threads["max"] = document.getElementById("server_websocket_worker_threads_max_id").value;
    newwebsocket["worker_threads"] = newworker_threads;
    newElem["websocket"] = newwebsocket;
    newElem["worker_threads"] = document.getElementById("server_worker_threads_id").value;
    newElem["sni"] = server_ssl_front_end_snirowData.server_ssl_front_end_sni;
    newElem["attributes"] = server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes;
    newElem["response_headers"] = server_response_headersrowData.server_response_headers;
    newElem["certificate"] = server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate;
    newElem["trust_certificates"] = server_ssl_trust_certificatesrowData.server_ssl_trust_certificates;
    newElem["protocols"] = server_protocolsrowData.server_protocols;
    newElem["ciphers"] = server_ssl_ciphersrowData.server_ssl_ciphers;
    newElem["client_ip_rules"] = server_client_ip_rulesrowData.server_client_ip_rules;
    newElem["enabled_languages"] = server_enabled_languagesrowData.server_enabled_languages;
    json["server"] = newElem;

    var yamlop = jsonToYaml(json);
    window.iagyaml = yamlop;
};

  const closeAdd = (idPrefix) => {

      if(idPrefix === undefined) idPrefix = "";

      updateStyle("server_div" + idPrefix, "display", "block");
      document.getElementById("server_tab" + idPrefix).style.display = "flex";

  };

const server_client_ip_rulesheaderData = [
    {
    header: 'IP Pattern',
    key: 'client_ip_rules',
  },

];

const server_client_ip_rulesrowData = {server_client_ip_rules: []};

const server_client_ip_ruleshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_client_ip_rules_client_ip_rules_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserver_client_ip_rulesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };
const server_enabled_languagesheaderData = [
    {
    header: 'Language',
    key: 'enabled_languages',
  },

];

const server_enabled_languagesrowData = {server_enabled_languages: []};

const server_enabled_languageshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_enabled_languages_enabled_languages_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserver_enabled_languagesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };
const server_local_applications_cred_viewer_attributesheaderData = [
    {
    header: 'Attribute',
    key: 'attributes',
  },

];

const server_local_applications_cred_viewer_attributesrowData = {server_local_applications_cred_viewer_attributes: []};

const server_local_applications_cred_viewer_attributeshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_local_applications_cred_viewer_attributes_attributes_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserverlocal_applicationscred_viewer_attributesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };
const server_protocolsheaderData = [
    {
    header: 'Protocol',
    key: 'protocols',
  },

];

const server_protocolsrowData = {server_protocols: []};

const server_protocolshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_protocols_protocols_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserver_protocolsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };
const server_response_headersheaderData = [
    {
    header: 'Attribute',
    key: 'attribute',
  },
{
    header: 'Header',
    key: 'header',
  },
{
    header: 'Macro',
    key: 'macro',
  },
{
    header: 'Text',
    key: 'text',
  },

];

const server_response_headersrowData = {server_response_headers: []};

const server_response_headershandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_response_headers_attribute_id" + idPrefix).value = "";
    document.getElementById("server_response_headers_header_id" + idPrefix).value = "";
    document.getElementById("server_response_headers_macro_id" + idPrefix).value = "";
    document.getElementById("server_response_headers_text_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserver_response_headersPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };
const server_ssl_ciphersheaderData = [
    {
    header: 'Cipher',
    key: 'ciphers',
  },

];

const server_ssl_ciphersrowData = {server_ssl_ciphers: []};

const server_ssl_ciphershandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_ssl_ciphers_ciphers_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserverssl_ciphersPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };
const server_ssl_front_end_certificateheaderData = [
    {
    header: 'Certificate',
    key: 'certificate',
  },

];

const server_ssl_front_end_certificaterowData = {server_ssl_front_end_certificate: []};

const server_ssl_front_end_certificatehandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_ssl_front_end_certificate_certificate_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserversslfront_end_certificatePage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };
const server_ssl_front_end_sniheaderData = [
    {
    header: 'Hostname',
    key: 'hostname',
  },

];

const server_ssl_front_end_snirowData = {server_ssl_front_end_sni: []};

const server_ssl_front_end_snihandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_ssl_front_end_sni_hostname_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserversslfront_end_sniPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };
const server_ssl_front_end_sni_certificateheaderData = [
    {
    header: 'Certificate',
    key: 'certificate',
  },

];

const server_ssl_front_end_sni_certificaterowData = {server_ssl_front_end_sni_certificate: []};

const server_ssl_front_end_sni_certificatehandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_ssl_front_end_sni_certificate_certificate_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserversslfront_endsni_certificatePage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };
const server_ssl_trust_certificatesheaderData = [
    {
    header: 'Trusted Certificates',
    key: 'trust_certificates',
  },

];

const server_ssl_trust_certificatesrowData = {server_ssl_trust_certificates: []};

const server_ssl_trust_certificateshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("server_ssl_trust_certificates_trust_certificates_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("server_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addserverssl_trust_certificatesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("server_tab" + idPrefix).style.display = "none";

  };


const ServerPage = () => {

  const idPrefix = "";

  if(window.iagpage != "ServerPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "ServerPage";
  }

    const [server_client_ip_rules, setserver_client_ip_rules] = React.useState([]);
    const [fetchedserver_client_ip_rules, setFetchedserver_client_ip_rules] = React.useState(false);

    React.useEffect(() => {
      server_client_ip_rulesloadGrid();
    }, [fetchedserver_client_ip_rules]);

    const server_client_ip_rulesloadGrid = React.useCallback(async (server_client_ip_rules_client_ip_rules, add) => {
      try {
        var attrs = [];
        if(server_client_ip_rules_client_ip_rules) {
          if(add) {
            for(var i = 0; i < server_client_ip_rulesrowData.server_client_ip_rules.length; i++) {
              var tempId = ((server_client_ip_rulesrowData.server_client_ip_rules[i].client_ip_rules)?server_client_ip_rulesrowData.server_client_ip_rules[i].client_ip_rules:"") + "";
              if((window.server_client_ip_rulesediting != true && window.server_client_ip_rulesediting != "true") || tempId != window.server_client_ip_rulesrowId) {
                attrs.push(server_client_ip_rulesrowData.server_client_ip_rules[i]);
              }
            }
            var newId = ((server_client_ip_rules_client_ip_rules)?server_client_ip_rules_client_ip_rules:"") + "";
            attrs.push({
              id: newId,
              client_ip_rules: server_client_ip_rules_client_ip_rules,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_client_ip_rulesrowData.server_client_ip_rules.length; i++) {
              if(server_client_ip_rulesrowData.server_client_ip_rules[i].client_ip_rules !== server_client_ip_rules_client_ip_rules ) {
                attrs.push(server_client_ip_rulesrowData.server_client_ip_rules[i]);
              }
            }
          }
        } else {
          attrs = server_client_ip_rulesrowData.server_client_ip_rules;
        }
        server_client_ip_rulesrowData.server_client_ip_rules = attrs;
        const data = {server_client_ip_rules: attrs};
        setserver_client_ip_rules(data.server_client_ip_rules);

        if(server_client_ip_rules_client_ip_rules !== undefined && server_client_ip_rules_client_ip_rules !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [server_enabled_languages, setserver_enabled_languages] = React.useState([]);
    const [fetchedserver_enabled_languages, setFetchedserver_enabled_languages] = React.useState(false);

    React.useEffect(() => {
      server_enabled_languagesloadGrid();
    }, [fetchedserver_enabled_languages]);

    const server_enabled_languagesloadGrid = React.useCallback(async (server_enabled_languages_enabled_languages, add) => {
      try {
        var attrs = [];
        if(server_enabled_languages_enabled_languages) {
          if(add) {
            for(var i = 0; i < server_enabled_languagesrowData.server_enabled_languages.length; i++) {
              var tempId = ((server_enabled_languagesrowData.server_enabled_languages[i].enabled_languages)?server_enabled_languagesrowData.server_enabled_languages[i].enabled_languages:"") + "";
              if((window.server_enabled_languagesediting != true && window.server_enabled_languagesediting != "true") || tempId != window.server_enabled_languagesrowId) {
                attrs.push(server_enabled_languagesrowData.server_enabled_languages[i]);
              }
            }
            var newId = ((server_enabled_languages_enabled_languages)?server_enabled_languages_enabled_languages:"") + "";
            attrs.push({
              id: newId,
              enabled_languages: server_enabled_languages_enabled_languages,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_enabled_languagesrowData.server_enabled_languages.length; i++) {
              if(server_enabled_languagesrowData.server_enabled_languages[i].enabled_languages !== server_enabled_languages_enabled_languages ) {
                attrs.push(server_enabled_languagesrowData.server_enabled_languages[i]);
              }
            }
          }
        } else {
          attrs = server_enabled_languagesrowData.server_enabled_languages;
        }
        server_enabled_languagesrowData.server_enabled_languages = attrs;
        const data = {server_enabled_languages: attrs};
        setserver_enabled_languages(data.server_enabled_languages);

        if(server_enabled_languages_enabled_languages !== undefined && server_enabled_languages_enabled_languages !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [server_local_applications_cred_viewer_attributes, setserver_local_applications_cred_viewer_attributes] = React.useState([]);
    const [fetchedserver_local_applications_cred_viewer_attributes, setFetchedserver_local_applications_cred_viewer_attributes] = React.useState(false);

    React.useEffect(() => {
      server_local_applications_cred_viewer_attributesloadGrid();
    }, [fetchedserver_local_applications_cred_viewer_attributes]);

    const server_local_applications_cred_viewer_attributesloadGrid = React.useCallback(async (server_local_applications_cred_viewer_attributes_attributes, add) => {
      try {
        var attrs = [];
        if(server_local_applications_cred_viewer_attributes_attributes) {
          if(add) {
            for(var i = 0; i < server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes.length; i++) {
              var tempId = ((server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes[i].attributes)?server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes[i].attributes:"") + "";
              if((window.server_local_applications_cred_viewer_attributesediting != true && window.server_local_applications_cred_viewer_attributesediting != "true") || tempId != window.server_local_applications_cred_viewer_attributesrowId) {
                attrs.push(server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes[i]);
              }
            }
            var newId = ((server_local_applications_cred_viewer_attributes_attributes)?server_local_applications_cred_viewer_attributes_attributes:"") + "";
            attrs.push({
              id: newId,
              attributes: server_local_applications_cred_viewer_attributes_attributes,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes.length; i++) {
              if(server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes[i].attributes !== server_local_applications_cred_viewer_attributes_attributes ) {
                attrs.push(server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes[i]);
              }
            }
          }
        } else {
          attrs = server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes;
        }
        server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes = attrs;
        const data = {server_local_applications_cred_viewer_attributes: attrs};
        setserver_local_applications_cred_viewer_attributes(data.server_local_applications_cred_viewer_attributes);

        if(server_local_applications_cred_viewer_attributes_attributes !== undefined && server_local_applications_cred_viewer_attributes_attributes !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [server_protocols, setserver_protocols] = React.useState([]);
    const [fetchedserver_protocols, setFetchedserver_protocols] = React.useState(false);

    React.useEffect(() => {
      server_protocolsloadGrid();
    }, [fetchedserver_protocols]);

    const server_protocolsloadGrid = React.useCallback(async (server_protocols_protocols, add) => {
      try {
        var attrs = [];
        if(server_protocols_protocols) {
          if(add) {
            for(var i = 0; i < server_protocolsrowData.server_protocols.length; i++) {
              var tempId = ((server_protocolsrowData.server_protocols[i].protocols)?server_protocolsrowData.server_protocols[i].protocols:"") + "";
              if((window.server_protocolsediting != true && window.server_protocolsediting != "true") || tempId != window.server_protocolsrowId) {
                attrs.push(server_protocolsrowData.server_protocols[i]);
              }
            }
            var newId = ((server_protocols_protocols)?server_protocols_protocols:"") + "";
            attrs.push({
              id: newId,
              protocols: server_protocols_protocols,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_protocolsrowData.server_protocols.length; i++) {
              if(server_protocolsrowData.server_protocols[i].protocols !== server_protocols_protocols ) {
                attrs.push(server_protocolsrowData.server_protocols[i]);
              }
            }
          }
        } else {
          attrs = server_protocolsrowData.server_protocols;
        }
        server_protocolsrowData.server_protocols = attrs;
        const data = {server_protocols: attrs};
        setserver_protocols(data.server_protocols);

        if(server_protocols_protocols !== undefined && server_protocols_protocols !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [server_response_headers, setserver_response_headers] = React.useState([]);
    const [fetchedserver_response_headers, setFetchedserver_response_headers] = React.useState(false);

    React.useEffect(() => {
      server_response_headersloadGrid();
    }, [fetchedserver_response_headers]);

    const server_response_headersloadGrid = React.useCallback(async (server_response_headers_attribute, server_response_headers_header, server_response_headers_macro, server_response_headers_text, add) => {
      try {
        var attrs = [];
        if(server_response_headers_header) {
          if(add) {
            for(var i = 0; i < server_response_headersrowData.server_response_headers.length; i++) {
              var tempId = ((server_response_headersrowData.server_response_headers[i].header)?server_response_headersrowData.server_response_headers[i].header:"") + "";
              if((window.server_response_headersediting != true && window.server_response_headersediting != "true") || tempId != window.server_response_headersrowId) {
                attrs.push(server_response_headersrowData.server_response_headers[i]);
              }
            }
            var newId = ((server_response_headers_header)?server_response_headers_header:"") + "";
            attrs.push({
              id: newId,
              attribute: server_response_headers_attribute,
header: server_response_headers_header,
macro: server_response_headers_macro,
text: server_response_headers_text,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_response_headersrowData.server_response_headers.length; i++) {
              if(server_response_headersrowData.server_response_headers[i].header !== server_response_headers_header ) {
                attrs.push(server_response_headersrowData.server_response_headers[i]);
              }
            }
          }
        } else {
          attrs = server_response_headersrowData.server_response_headers;
        }
        server_response_headersrowData.server_response_headers = attrs;
        const data = {server_response_headers: attrs};
        setserver_response_headers(data.server_response_headers);

        if(server_response_headers_header !== undefined && server_response_headers_header !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [server_ssl_ciphers, setserver_ssl_ciphers] = React.useState([]);
    const [fetchedserver_ssl_ciphers, setFetchedserver_ssl_ciphers] = React.useState(false);

    React.useEffect(() => {
      server_ssl_ciphersloadGrid();
    }, [fetchedserver_ssl_ciphers]);

    const server_ssl_ciphersloadGrid = React.useCallback(async (server_ssl_ciphers_ciphers, add) => {
      try {
        var attrs = [];
        if(server_ssl_ciphers_ciphers) {
          if(add) {
            for(var i = 0; i < server_ssl_ciphersrowData.server_ssl_ciphers.length; i++) {
              var tempId = ((server_ssl_ciphersrowData.server_ssl_ciphers[i].ciphers)?server_ssl_ciphersrowData.server_ssl_ciphers[i].ciphers:"") + "";
              if((window.server_ssl_ciphersediting != true && window.server_ssl_ciphersediting != "true") || tempId != window.server_ssl_ciphersrowId) {
                attrs.push(server_ssl_ciphersrowData.server_ssl_ciphers[i]);
              }
            }
            var newId = ((server_ssl_ciphers_ciphers)?server_ssl_ciphers_ciphers:"") + "";
            attrs.push({
              id: newId,
              ciphers: server_ssl_ciphers_ciphers,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_ssl_ciphersrowData.server_ssl_ciphers.length; i++) {
              if(server_ssl_ciphersrowData.server_ssl_ciphers[i].ciphers !== server_ssl_ciphers_ciphers ) {
                attrs.push(server_ssl_ciphersrowData.server_ssl_ciphers[i]);
              }
            }
          }
        } else {
          attrs = server_ssl_ciphersrowData.server_ssl_ciphers;
        }
        server_ssl_ciphersrowData.server_ssl_ciphers = attrs;
        const data = {server_ssl_ciphers: attrs};
        setserver_ssl_ciphers(data.server_ssl_ciphers);

        if(server_ssl_ciphers_ciphers !== undefined && server_ssl_ciphers_ciphers !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [server_ssl_front_end_certificate, setserver_ssl_front_end_certificate] = React.useState([]);
    const [fetchedserver_ssl_front_end_certificate, setFetchedserver_ssl_front_end_certificate] = React.useState(false);

    React.useEffect(() => {
      server_ssl_front_end_certificateloadGrid();
    }, [fetchedserver_ssl_front_end_certificate]);

    const server_ssl_front_end_certificateloadGrid = React.useCallback(async (server_ssl_front_end_certificate_certificate, add) => {
      try {
        var attrs = [];
        if(server_ssl_front_end_certificate_certificate) {
          if(add) {
            for(var i = 0; i < server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate.length; i++) {
              var tempId = ((server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate[i].certificate)?server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate[i].certificate:"") + "";
              if((window.server_ssl_front_end_certificateediting != true && window.server_ssl_front_end_certificateediting != "true") || tempId != window.server_ssl_front_end_certificaterowId) {
                attrs.push(server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate[i]);
              }
            }
            var newId = ((server_ssl_front_end_certificate_certificate)?server_ssl_front_end_certificate_certificate:"") + "";
            attrs.push({
              id: newId,
              certificate: server_ssl_front_end_certificate_certificate,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate.length; i++) {
              if(server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate[i].certificate !== server_ssl_front_end_certificate_certificate ) {
                attrs.push(server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate[i]);
              }
            }
          }
        } else {
          attrs = server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate;
        }
        server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate = attrs;
        const data = {server_ssl_front_end_certificate: attrs};
        setserver_ssl_front_end_certificate(data.server_ssl_front_end_certificate);

        if(server_ssl_front_end_certificate_certificate !== undefined && server_ssl_front_end_certificate_certificate !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [server_ssl_front_end_sni, setserver_ssl_front_end_sni] = React.useState([]);
    const [fetchedserver_ssl_front_end_sni, setFetchedserver_ssl_front_end_sni] = React.useState(false);

    React.useEffect(() => {
      server_ssl_front_end_sniloadGrid();
    }, [fetchedserver_ssl_front_end_sni]);

    const server_ssl_front_end_sniloadGrid = React.useCallback(async (server_ssl_front_end_sni_hostname, server_ssl_front_end_sni_certificate,add) => {
      try {
        var attrs = [];
        if(server_ssl_front_end_sni_hostname) {
          if(add) {
            for(var i = 0; i < server_ssl_front_end_snirowData.server_ssl_front_end_sni.length; i++) {
              var tempId = ((server_ssl_front_end_snirowData.server_ssl_front_end_sni[i].hostname)?server_ssl_front_end_snirowData.server_ssl_front_end_sni[i].hostname:"") + "";
              if((window.server_ssl_front_end_sniediting != true && window.server_ssl_front_end_sniediting != "true") || tempId != window.server_ssl_front_end_snirowId) {
                attrs.push(server_ssl_front_end_snirowData.server_ssl_front_end_sni[i]);
              }
            }
            var newId = ((server_ssl_front_end_sni_hostname)?server_ssl_front_end_sni_hostname:"") + "";
            attrs.push({
              id: newId,
              certificate: server_ssl_front_end_sni_certificate,
hostname: server_ssl_front_end_sni_hostname,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_ssl_front_end_snirowData.server_ssl_front_end_sni.length; i++) {
              if(server_ssl_front_end_snirowData.server_ssl_front_end_sni[i].hostname !== server_ssl_front_end_sni_hostname ) {
                attrs.push(server_ssl_front_end_snirowData.server_ssl_front_end_sni[i]);
              }
            }
          }
        } else {
          attrs = server_ssl_front_end_snirowData.server_ssl_front_end_sni;
        }
        server_ssl_front_end_snirowData.server_ssl_front_end_sni = attrs;
        const data = {server_ssl_front_end_sni: attrs};
        setserver_ssl_front_end_sni(data.server_ssl_front_end_sni);

        if(server_ssl_front_end_sni_hostname !== undefined && server_ssl_front_end_sni_hostname !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [server_ssl_front_end_sni_certificate, setserver_ssl_front_end_sni_certificate] = React.useState([]);
    const [fetchedserver_ssl_front_end_sni_certificate, setFetchedserver_ssl_front_end_sni_certificate] = React.useState(false);

    React.useEffect(() => {
      server_ssl_front_end_sni_certificateloadGrid();
    }, [fetchedserver_ssl_front_end_sni_certificate]);

    const server_ssl_front_end_sni_certificateloadGrid = React.useCallback(async (server_ssl_front_end_sni_certificate_certificate, add) => {
      try {
        var attrs = [];
        if(server_ssl_front_end_sni_certificate_certificate) {
          if(add) {
            for(var i = 0; i < server_ssl_front_end_sni_certificaterowData.server_ssl_front_end_sni_certificate.length; i++) {
              var tempId = ((server_ssl_front_end_sni_certificaterowData.server_ssl_front_end_sni_certificate[i].certificate)?server_ssl_front_end_sni_certificaterowData.server_ssl_front_end_sni_certificate[i].certificate:"") + "";
              if((window.server_ssl_front_end_sni_certificateediting != true && window.server_ssl_front_end_sni_certificateediting != "true") || tempId != window.server_ssl_front_end_sni_certificaterowId) {
                attrs.push(server_ssl_front_end_sni_certificaterowData.server_ssl_front_end_sni_certificate[i]);
              }
            }
            var newId = ((server_ssl_front_end_sni_certificate_certificate)?server_ssl_front_end_sni_certificate_certificate:"") + "";
            attrs.push({
              id: newId,
              certificate: server_ssl_front_end_sni_certificate_certificate,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_ssl_front_end_sni_certificaterowData.server_ssl_front_end_sni_certificate.length; i++) {
              if(server_ssl_front_end_sni_certificaterowData.server_ssl_front_end_sni_certificate[i].certificate !== server_ssl_front_end_sni_certificate_certificate ) {
                attrs.push(server_ssl_front_end_sni_certificaterowData.server_ssl_front_end_sni_certificate[i]);
              }
            }
          }
        } else {
          attrs = server_ssl_front_end_sni_certificaterowData.server_ssl_front_end_sni_certificate;
        }
        server_ssl_front_end_sni_certificaterowData.server_ssl_front_end_sni_certificate = attrs;
        const data = {server_ssl_front_end_sni_certificate: attrs};
        setserver_ssl_front_end_sni_certificate(data.server_ssl_front_end_sni_certificate);

        if(server_ssl_front_end_sni_certificate_certificate !== undefined && server_ssl_front_end_sni_certificate_certificate !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [server_ssl_trust_certificates, setserver_ssl_trust_certificates] = React.useState([]);
    const [fetchedserver_ssl_trust_certificates, setFetchedserver_ssl_trust_certificates] = React.useState(false);

    React.useEffect(() => {
      server_ssl_trust_certificatesloadGrid();
    }, [fetchedserver_ssl_trust_certificates]);

    const server_ssl_trust_certificatesloadGrid = React.useCallback(async (server_ssl_trust_certificates_trust_certificates, add) => {
      try {
        var attrs = [];
        if(server_ssl_trust_certificates_trust_certificates) {
          if(add) {
            for(var i = 0; i < server_ssl_trust_certificatesrowData.server_ssl_trust_certificates.length; i++) {
              var tempId = ((server_ssl_trust_certificatesrowData.server_ssl_trust_certificates[i].trust_certificates)?server_ssl_trust_certificatesrowData.server_ssl_trust_certificates[i].trust_certificates:"") + "";
              if((window.server_ssl_trust_certificatesediting != true && window.server_ssl_trust_certificatesediting != "true") || tempId != window.server_ssl_trust_certificatesrowId) {
                attrs.push(server_ssl_trust_certificatesrowData.server_ssl_trust_certificates[i]);
              }
            }
            var newId = ((server_ssl_trust_certificates_trust_certificates)?server_ssl_trust_certificates_trust_certificates:"") + "";
            attrs.push({
              id: newId,
              trust_certificates: server_ssl_trust_certificates_trust_certificates,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < server_ssl_trust_certificatesrowData.server_ssl_trust_certificates.length; i++) {
              if(server_ssl_trust_certificatesrowData.server_ssl_trust_certificates[i].trust_certificates !== server_ssl_trust_certificates_trust_certificates ) {
                attrs.push(server_ssl_trust_certificatesrowData.server_ssl_trust_certificates[i]);
              }
            }
          }
        } else {
          attrs = server_ssl_trust_certificatesrowData.server_ssl_trust_certificates;
        }
        server_ssl_trust_certificatesrowData.server_ssl_trust_certificates = attrs;
        const data = {server_ssl_trust_certificates: attrs};
        setserver_ssl_trust_certificates(data.server_ssl_trust_certificates);

        if(server_ssl_trust_certificates_trust_certificates !== undefined && server_ssl_trust_certificates_trust_certificates !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });



    const [server_client_ip_rules_client_ip_rules, setserver_client_ip_rules_client_ip_rules] = useState(''),
    updateserver_client_ip_rules_client_ip_rules = useCallback((evt) => {
      setserver_client_ip_rules_client_ip_rules(evt.target.value);
      var tempId = evt.target.value;
      validateField(server_client_ip_rulesrowData.server_client_ip_rules, setserver_client_ip_rules_client_ip_rules_valid, setserver_client_ip_rules_client_ip_rules_invalid_text, "Server Client Ip Rules", "client_ip_rules", tempId);
    }, []);

    const [server_client_ip_rules_client_ip_rules_valid, setserver_client_ip_rules_client_ip_rules_valid] = useState(true);
    const [server_client_ip_rules_client_ip_rules_invalid_text, setserver_client_ip_rules_client_ip_rules_invalid_text] = useState("");


    const [server_content_security_policy, setserver_content_security_policy] = useState('default'),
    updateserver_content_security_policy = useCallback((evt) => setserver_content_security_policy(evt.target.value), []);

    const [server_credential_service_cache_cache_enabled, setserver_credential_service_cache_cache_enabled] = useState(false),
    updateserver_credential_service_cache_cache_enabled = useCallback((evt) => setserver_credential_service_cache_cache_enabled(evt), []);

    const [server_credential_service_cache_cache_size, setserver_credential_service_cache_cache_size] = useState(1024),
    updateserver_credential_service_cache_cache_size = useCallback((evt) => {}, []);

    const [server_credential_service_cache_entry_idle_timeout, setserver_credential_service_cache_entry_idle_timeout] = useState(900),
    updateserver_credential_service_cache_entry_idle_timeout = useCallback((evt) => {}, []);

    const [server_credential_service_cache_entry_lifetime, setserver_credential_service_cache_entry_lifetime] = useState(900),
    updateserver_credential_service_cache_entry_lifetime = useCallback((evt) => {}, []);

    const [server_credential_service_cache_login_clear_user, setserver_credential_service_cache_login_clear_user] = useState(false),
    updateserver_credential_service_cache_login_clear_user = useCallback((evt) => setserver_credential_service_cache_login_clear_user(evt), []);

    const [server_enabled_languages_enabled_languages, setserver_enabled_languages_enabled_languages] = useState(''),
    updateserver_enabled_languages_enabled_languages = useCallback((evt) => {
      setserver_enabled_languages_enabled_languages(evt.target.value);
      var tempId = evt.target.value;
      validateField(server_enabled_languagesrowData.server_enabled_languages, setserver_enabled_languages_enabled_languages_valid, setserver_enabled_languages_enabled_languages_invalid_text, "Server Enabled Languages", "enabled_languages", tempId);
    }, []);

    const [server_enabled_languages_enabled_languages_valid, setserver_enabled_languages_enabled_languages_valid] = useState(true);
    const [server_enabled_languages_enabled_languages_invalid_text, setserver_enabled_languages_enabled_languages_invalid_text] = useState("");


    const [server_error_pages_content, setserver_error_pages_content] = useState(''),
    updateserver_error_pages_content = useCallback((evt) => setserver_error_pages_content(evt.target.value), []);

    const [server_error_pages_type, setserver_error_pages_type] = useState(''),
    updateserver_error_pages_type = useCallback((evt) => setserver_error_pages_type(evt.target.value), []);

    const [server_failover_cookie_name, setserver_failover_cookie_name] = useState(''),
    updateserver_failover_cookie_name = useCallback((evt) => setserver_failover_cookie_name(evt.target.value), []);

    const [server_failover_domain_cookie, setserver_failover_domain_cookie] = useState(false),
    updateserver_failover_domain_cookie = useCallback((evt) => setserver_failover_domain_cookie(evt), []);

    const [server_failover_key, setserver_failover_key] = useState(''),
    updateserver_failover_key = useCallback((evt) => setserver_failover_key(evt.target.value), []);

    const [server_http2, setserver_http2] = useState(true),
    updateserver_http2 = useCallback((evt) => setserver_http2(evt), []);

    const [server_local_applications_azn_decision_max_cache_lifetime, setserver_local_applications_azn_decision_max_cache_lifetime] = useState(300),
    updateserver_local_applications_azn_decision_max_cache_lifetime = useCallback((evt) => {}, []);

    const [server_local_applications_azn_decision_max_cache_size, setserver_local_applications_azn_decision_max_cache_size] = useState(8192),
    updateserver_local_applications_azn_decision_max_cache_size = useCallback((evt) => {}, []);

    const [server_local_applications_azn_decision_path_segment, setserver_local_applications_azn_decision_path_segment] = useState(''),
    updateserver_local_applications_azn_decision_path_segment = useCallback((evt) => setserver_local_applications_azn_decision_path_segment(evt.target.value), []);

    const [server_local_applications_cred_viewer_attributes_attributes, setserver_local_applications_cred_viewer_attributes_attributes] = useState(''),
    updateserver_local_applications_cred_viewer_attributes_attributes = useCallback((evt) => {
      setserver_local_applications_cred_viewer_attributes_attributes(evt.target.value);
      var tempId = evt.target.value;
      validateField(server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes, setserver_local_applications_cred_viewer_attributes_attributes_valid, setserver_local_applications_cred_viewer_attributes_attributes_invalid_text, "Server Local Applications Cred Viewer Attributes", "attributes", tempId);
    }, []);

    const [server_local_applications_cred_viewer_attributes_attributes_valid, setserver_local_applications_cred_viewer_attributes_attributes_valid] = useState(true);
    const [server_local_applications_cred_viewer_attributes_attributes_invalid_text, setserver_local_applications_cred_viewer_attributes_attributes_invalid_text] = useState("");


    const [server_local_applications_cred_viewer_enable_html, setserver_local_applications_cred_viewer_enable_html] = useState(true),
    updateserver_local_applications_cred_viewer_enable_html = useCallback((evt) => setserver_local_applications_cred_viewer_enable_html(evt), []);

    const [server_local_applications_cred_viewer_path_segment, setserver_local_applications_cred_viewer_path_segment] = useState(''),
    updateserver_local_applications_cred_viewer_path_segment = useCallback((evt) => setserver_local_applications_cred_viewer_path_segment(evt.target.value), []);

    const [server_local_applications_jwks_path_segment, setserver_local_applications_jwks_path_segment] = useState(''),
    updateserver_local_applications_jwks_path_segment = useCallback((evt) => setserver_local_applications_jwks_path_segment(evt.target.value), []);

    const [server_local_pages_content, setserver_local_pages_content] = useState(''),
    updateserver_local_pages_content = useCallback((evt) => setserver_local_pages_content(evt.target.value), []);

    const [server_local_pages_type, setserver_local_pages_type] = useState(''),
    updateserver_local_pages_type = useCallback((evt) => setserver_local_pages_type(evt.target.value), []);

    const [server_management_pages_content, setserver_management_pages_content] = useState(''),
    updateserver_management_pages_content = useCallback((evt) => setserver_management_pages_content(evt.target.value), []);

    const [server_management_pages_type, setserver_management_pages_type] = useState(''),
    updateserver_management_pages_type = useCallback((evt) => setserver_management_pages_type(evt.target.value), []);

    const [server_protocols_protocols, setserver_protocols_protocols] = useState('https'),
    updateserver_protocols_protocols = useCallback((evt) => {
      setserver_protocols_protocols(evt.target.value);
      var tempId = evt.target.value;
      validateField(server_protocolsrowData.server_protocols, setserver_protocols_protocols_valid, setserver_protocols_protocols_invalid_text, "Server Protocols", "protocols", tempId);
    }, []);

    const [server_protocols_protocols_valid, setserver_protocols_protocols_valid] = useState(true);
    const [server_protocols_protocols_invalid_text, setserver_protocols_protocols_invalid_text] = useState("");


    const [server_public_assets_content, setserver_public_assets_content] = useState(''),
    updateserver_public_assets_content = useCallback((evt) => setserver_public_assets_content(evt.target.value), []);

    const [server_public_assets_path_segment, setserver_public_assets_path_segment] = useState('pkmspublic'),
    updateserver_public_assets_path_segment = useCallback((evt) => setserver_public_assets_path_segment(evt.target.value), []);

    const [server_public_assets_type, setserver_public_assets_type] = useState(''),
    updateserver_public_assets_type = useCallback((evt) => setserver_public_assets_type(evt.target.value), []);

    const [server_rate_limiting_cache_size, setserver_rate_limiting_cache_size] = useState(16384),
    updateserver_rate_limiting_cache_size = useCallback((evt) => {}, []);

    const [server_rate_limiting_redis_collection_name, setserver_rate_limiting_redis_collection_name] = useState(''),
    updateserver_rate_limiting_redis_collection_name = useCallback((evt) => setserver_rate_limiting_redis_collection_name(evt.target.value), []);

    const [server_rate_limiting_redis_sync_window, setserver_rate_limiting_redis_sync_window] = useState(5),
    updateserver_rate_limiting_redis_sync_window = useCallback((evt) => {}, []);

    const [server_rate_limiting_response_headers, setserver_rate_limiting_response_headers] = useState(false),
    updateserver_rate_limiting_response_headers = useCallback((evt) => setserver_rate_limiting_response_headers(evt), []);

    const [server_response_headers_attribute, setserver_response_headers_attribute] = useState(''),
    updateserver_response_headers_attribute = useCallback((evt) => setserver_response_headers_attribute(evt.target.value), []);

    const [server_response_headers_header, setserver_response_headers_header] = useState(''),
    updateserver_response_headers_header = useCallback((evt) => {
      setserver_response_headers_header(evt.target.value);
      var tempId = evt.target.value;
      validateField(server_response_headersrowData.server_response_headers, setserver_response_headers_header_valid, setserver_response_headers_header_invalid_text, "Server Response Headers", "header", tempId);
    }, []);

    const [server_response_headers_header_valid, setserver_response_headers_header_valid] = useState(true);
    const [server_response_headers_header_invalid_text, setserver_response_headers_header_invalid_text] = useState("");


    const [server_response_headers_macro, setserver_response_headers_macro] = useState(''),
    updateserver_response_headers_macro = useCallback((evt) => setserver_response_headers_macro(evt.target.value), []);

    const [server_response_headers_text, setserver_response_headers_text] = useState(''),
    updateserver_response_headers_text = useCallback((evt) => setserver_response_headers_text(evt.target.value), []);

    const [server_session_cookie_name, setserver_session_cookie_name] = useState('PD-S-SESSION-ID'),
    updateserver_session_cookie_name = useCallback((evt) => setserver_session_cookie_name(evt.target.value), []);

    const [server_session_inactive_timeout, setserver_session_inactive_timeout] = useState(600),
    updateserver_session_inactive_timeout = useCallback((evt) => {}, []);

    const [server_session_max_sessions, setserver_session_max_sessions] = useState(4096),
    updateserver_session_max_sessions = useCallback((evt) => {}, []);

    const [server_session_permit_user_switching, setserver_session_permit_user_switching] = useState(false),
    updateserver_session_permit_user_switching = useCallback((evt) => setserver_session_permit_user_switching(evt), []);

    const [server_session_reauth_login_time_window, setserver_session_reauth_login_time_window] = useState(0),
    updateserver_session_reauth_login_time_window = useCallback((evt) => {}, []);

    const [server_session_redis_client_list_cache_lifetime, setserver_session_redis_client_list_cache_lifetime] = useState(10),
    updateserver_session_redis_client_list_cache_lifetime = useCallback((evt) => {}, []);

    const [server_session_redis_concurrent_sessions_enabled, setserver_session_redis_concurrent_sessions_enabled] = useState(true),
    updateserver_session_redis_concurrent_sessions_enabled = useCallback((evt) => setserver_session_redis_concurrent_sessions_enabled(evt), []);

    const [server_session_redis_concurrent_sessions_max_user_sessions, setserver_session_redis_concurrent_sessions_max_user_sessions] = useState(0),
    updateserver_session_redis_concurrent_sessions_max_user_sessions = useCallback((evt) => {}, []);

    const [server_session_redis_concurrent_sessions_prompt_for_displacement, setserver_session_redis_concurrent_sessions_prompt_for_displacement] = useState(true),
    updateserver_session_redis_concurrent_sessions_prompt_for_displacement = useCallback((evt) => setserver_session_redis_concurrent_sessions_prompt_for_displacement(evt), []);

    const [server_session_redis_concurrent_sessions_user_identity_attribute_name, setserver_session_redis_concurrent_sessions_user_identity_attribute_name] = useState('AZN_CRED_PRINCIPAL_NAME'),
    updateserver_session_redis_concurrent_sessions_user_identity_attribute_name = useCallback((evt) => setserver_session_redis_concurrent_sessions_user_identity_attribute_name(evt.target.value), []);

    const [server_session_redis_enabled, setserver_session_redis_enabled] = useState(),
    updateserver_session_redis_enabled = useCallback((evt) => setserver_session_redis_enabled(evt), []);

    const [server_session_timeout, setserver_session_timeout] = useState(3600),
    updateserver_session_timeout = useCallback((evt) => {}, []);

    const [server_ssl_applications_tlsv10, setserver_ssl_applications_tlsv10] = useState(false),
    updateserver_ssl_applications_tlsv10 = useCallback((evt) => setserver_ssl_applications_tlsv10(evt), []);

    const [server_ssl_applications_tlsv11, setserver_ssl_applications_tlsv11] = useState(false),
    updateserver_ssl_applications_tlsv11 = useCallback((evt) => setserver_ssl_applications_tlsv11(evt), []);

    const [server_ssl_applications_tlsv12, setserver_ssl_applications_tlsv12] = useState(true),
    updateserver_ssl_applications_tlsv12 = useCallback((evt) => setserver_ssl_applications_tlsv12(evt), []);

    const [server_ssl_applications_tlsv13, setserver_ssl_applications_tlsv13] = useState(false),
    updateserver_ssl_applications_tlsv13 = useCallback((evt) => setserver_ssl_applications_tlsv13(evt), []);

    const [server_ssl_ciphers_ciphers, setserver_ssl_ciphers_ciphers] = useState(''),
    updateserver_ssl_ciphers_ciphers = useCallback((evt) => {
      setserver_ssl_ciphers_ciphers(evt.target.value);
      var tempId = evt.target.value;
      validateField(server_ssl_ciphersrowData.server_ssl_ciphers, setserver_ssl_ciphers_ciphers_valid, setserver_ssl_ciphers_ciphers_invalid_text, "Server Ssl Ciphers", "ciphers", tempId);
    }, []);

    const [server_ssl_ciphers_ciphers_valid, setserver_ssl_ciphers_ciphers_valid] = useState(true);
    const [server_ssl_ciphers_ciphers_invalid_text, setserver_ssl_ciphers_ciphers_invalid_text] = useState("");


    const [server_ssl_front_end_certificate_certificate, setserver_ssl_front_end_certificate_certificate] = useState(''),
    updateserver_ssl_front_end_certificate_certificate = useCallback((evt) => {
      setserver_ssl_front_end_certificate_certificate(evt.target.value);
      var tempId = evt.target.value;
      validateField(server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate, setserver_ssl_front_end_certificate_certificate_valid, setserver_ssl_front_end_certificate_certificate_invalid_text, "Server Ssl Front End Certificate", "certificate", tempId);
    }, []);

    const [server_ssl_front_end_certificate_certificate_valid, setserver_ssl_front_end_certificate_certificate_valid] = useState(true);
    const [server_ssl_front_end_certificate_certificate_invalid_text, setserver_ssl_front_end_certificate_certificate_invalid_text] = useState("");


    const [server_ssl_front_end_sni_hostname, setserver_ssl_front_end_sni_hostname] = useState(''),
    updateserver_ssl_front_end_sni_hostname = useCallback((evt) => {
      setserver_ssl_front_end_sni_hostname(evt.target.value);
      var tempId = evt.target.value;
      validateField(server_ssl_front_end_snirowData.server_ssl_front_end_sni, setserver_ssl_front_end_sni_hostname_valid, setserver_ssl_front_end_sni_hostname_invalid_text, "Server Ssl Front End Sni", "hostname", tempId);
    }, []);

    const [server_ssl_front_end_sni_hostname_valid, setserver_ssl_front_end_sni_hostname_valid] = useState(true);
    const [server_ssl_front_end_sni_hostname_invalid_text, setserver_ssl_front_end_sni_hostname_invalid_text] = useState("");


    const [server_ssl_front_end_tlsv10, setserver_ssl_front_end_tlsv10] = useState(false),
    updateserver_ssl_front_end_tlsv10 = useCallback((evt) => setserver_ssl_front_end_tlsv10(evt), []);

    const [server_ssl_front_end_tlsv11, setserver_ssl_front_end_tlsv11] = useState(false),
    updateserver_ssl_front_end_tlsv11 = useCallback((evt) => setserver_ssl_front_end_tlsv11(evt), []);

    const [server_ssl_front_end_tlsv12, setserver_ssl_front_end_tlsv12] = useState(true),
    updateserver_ssl_front_end_tlsv12 = useCallback((evt) => setserver_ssl_front_end_tlsv12(evt), []);

    const [server_ssl_front_end_tlsv13, setserver_ssl_front_end_tlsv13] = useState(false),
    updateserver_ssl_front_end_tlsv13 = useCallback((evt) => setserver_ssl_front_end_tlsv13(evt), []);

    const [server_ssl_trust_certificates_trust_certificates, setserver_ssl_trust_certificates_trust_certificates] = useState(''),
    updateserver_ssl_trust_certificates_trust_certificates = useCallback((evt) => {
      setserver_ssl_trust_certificates_trust_certificates(evt.target.value);
      var tempId = evt.target.value;
      validateField(server_ssl_trust_certificatesrowData.server_ssl_trust_certificates, setserver_ssl_trust_certificates_trust_certificates_valid, setserver_ssl_trust_certificates_trust_certificates_invalid_text, "Server Ssl Trust Certificates", "trust_certificates", tempId);
    }, []);

    const [server_ssl_trust_certificates_trust_certificates_valid, setserver_ssl_trust_certificates_trust_certificates_valid] = useState(true);
    const [server_ssl_trust_certificates_trust_certificates_invalid_text, setserver_ssl_trust_certificates_trust_certificates_invalid_text] = useState("");


    const [server_websocket_timeouts_applications_read, setserver_websocket_timeouts_applications_read] = useState(120),
    updateserver_websocket_timeouts_applications_read = useCallback((evt) => {}, []);

    const [server_websocket_timeouts_applications_write, setserver_websocket_timeouts_applications_write] = useState(20),
    updateserver_websocket_timeouts_applications_write = useCallback((evt) => {}, []);

    const [server_websocket_timeouts_front_end_read, setserver_websocket_timeouts_front_end_read] = useState(120),
    updateserver_websocket_timeouts_front_end_read = useCallback((evt) => {}, []);

    const [server_websocket_timeouts_front_end_write, setserver_websocket_timeouts_front_end_write] = useState(20),
    updateserver_websocket_timeouts_front_end_write = useCallback((evt) => {}, []);

    const [server_websocket_worker_threads_idle, setserver_websocket_worker_threads_idle] = useState(0),
    updateserver_websocket_worker_threads_idle = useCallback((evt) => {}, []);

    const [server_websocket_worker_threads_max, setserver_websocket_worker_threads_max] = useState(0),
    updateserver_websocket_worker_threads_max = useCallback((evt) => {}, []);

    const [server_worker_threads, setserver_worker_threads] = useState(100),
    updateserver_worker_threads = useCallback((evt) => {}, []);


  if(window.iagpage != "ServerPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "ServerPage";
  }

    const [fetcheddata, setFetcheddata] = React.useState(false);
    React.useEffect(() => {
      dataLoad();
    }, [fetcheddata]);
    const dataLoad = () => {
      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

      for(var i = 0; i < server_client_ip_rulesrowData.server_client_ip_rules.length; i++) {
        if(server_client_ip_rulesrowData.server_client_ip_rules[i].id === window.server_client_ip_rulesrowId) {
        setserver_client_ip_rules_client_ip_rules((server_client_ip_rulesrowData.server_client_ip_rules[i] !== undefined && server_client_ip_rulesrowData.server_client_ip_rules[i].client_ip_rules !== undefined )?server_client_ip_rulesrowData.server_client_ip_rules[i].client_ip_rules:"");
        }
      }

      for(var i = 0; i < server_enabled_languagesrowData.server_enabled_languages.length; i++) {
        if(server_enabled_languagesrowData.server_enabled_languages[i].id === window.server_enabled_languagesrowId) {
        setserver_enabled_languages_enabled_languages((server_enabled_languagesrowData.server_enabled_languages[i] !== undefined && server_enabled_languagesrowData.server_enabled_languages[i].enabled_languages !== undefined )?server_enabled_languagesrowData.server_enabled_languages[i].enabled_languages:"");
        }
      }

      for(var i = 0; i < server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes.length; i++) {
        if(server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes[i].id === window.server_local_applications_cred_viewer_attributesrowId) {
        setserver_local_applications_cred_viewer_attributes_attributes((server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes[i] !== undefined && server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes[i].attributes !== undefined )?server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes[i].attributes:"");
        }
      }

      for(var i = 0; i < server_protocolsrowData.server_protocols.length; i++) {
        if(server_protocolsrowData.server_protocols[i].id === window.server_protocolsrowId) {
        setserver_protocols_protocols((server_protocolsrowData.server_protocols[i] !== undefined && server_protocolsrowData.server_protocols[i].protocols !== undefined )?server_protocolsrowData.server_protocols[i].protocols:"");
        }
      }

      for(var i = 0; i < server_response_headersrowData.server_response_headers.length; i++) {
        if(server_response_headersrowData.server_response_headers[i].id === window.server_response_headersrowId) {
        setserver_response_headers_attribute((server_response_headersrowData.server_response_headers[i] !== undefined && server_response_headersrowData.server_response_headers[i].attribute !== undefined )?server_response_headersrowData.server_response_headers[i].attribute:"");
        setserver_response_headers_header((server_response_headersrowData.server_response_headers[i] !== undefined && server_response_headersrowData.server_response_headers[i].header !== undefined )?server_response_headersrowData.server_response_headers[i].header:"");
        setserver_response_headers_macro((server_response_headersrowData.server_response_headers[i] !== undefined && server_response_headersrowData.server_response_headers[i].macro !== undefined )?server_response_headersrowData.server_response_headers[i].macro:"");
        setserver_response_headers_text((server_response_headersrowData.server_response_headers[i] !== undefined && server_response_headersrowData.server_response_headers[i].text !== undefined )?server_response_headersrowData.server_response_headers[i].text:"");
        }
      }

      for(var i = 0; i < server_ssl_ciphersrowData.server_ssl_ciphers.length; i++) {
        if(server_ssl_ciphersrowData.server_ssl_ciphers[i].id === window.server_ssl_ciphersrowId) {
        setserver_ssl_ciphers_ciphers((server_ssl_ciphersrowData.server_ssl_ciphers[i] !== undefined && server_ssl_ciphersrowData.server_ssl_ciphers[i].ciphers !== undefined )?server_ssl_ciphersrowData.server_ssl_ciphers[i].ciphers:"");
        }
      }

      for(var i = 0; i < server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate.length; i++) {
        if(server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate[i].id === window.server_ssl_front_end_certificaterowId) {
        setserver_ssl_front_end_certificate_certificate((server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate[i] !== undefined && server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate[i].certificate !== undefined )?server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate[i].certificate:"");
        }
      }

      for(var i = 0; i < server_ssl_front_end_snirowData.server_ssl_front_end_sni.length; i++) {
        if(server_ssl_front_end_snirowData.server_ssl_front_end_sni[i].id === window.server_ssl_front_end_snirowId) {
        setserver_ssl_front_end_sni_hostname((server_ssl_front_end_snirowData.server_ssl_front_end_sni[i] !== undefined && server_ssl_front_end_snirowData.server_ssl_front_end_sni[i].hostname !== undefined )?server_ssl_front_end_snirowData.server_ssl_front_end_sni[i].hostname:"");
        }
      }

      for(var i = 0; i < server_ssl_trust_certificatesrowData.server_ssl_trust_certificates.length; i++) {
        if(server_ssl_trust_certificatesrowData.server_ssl_trust_certificates[i].id === window.server_ssl_trust_certificatesrowId) {
        setserver_ssl_trust_certificates_trust_certificates((server_ssl_trust_certificatesrowData.server_ssl_trust_certificates[i] !== undefined && server_ssl_trust_certificatesrowData.server_ssl_trust_certificates[i].trust_certificates !== undefined )?server_ssl_trust_certificatesrowData.server_ssl_trust_certificates[i].trust_certificates:"");
        }
      }


      return true;
    };
    const [fetchedserver, setFetchedserver] = React.useState(false);
    React.useEffect(() => {
      getserver();
    }, [fetchedserver]);

    const getserver = () => {

      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

            server_client_ip_rulesrowData.server_client_ip_rules = [];
            server_enabled_languagesrowData.server_enabled_languages = [];
                server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes = [];
            server_protocolsrowData.server_protocols = [];
            server_response_headersrowData.server_response_headers = [];
              server_ssl_ciphersrowData.server_ssl_ciphers = [];
                server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate = [];
                server_ssl_front_end_snirowData.server_ssl_front_end_sni = [];
              server_ssl_trust_certificatesrowData.server_ssl_trust_certificates = [];

        if(json !== undefined && json.server !== undefined ) {
          if(json !== undefined && json.server !== undefined && json.server.client_ip_rules !== undefined ) {
            var newclient_ip_ruless = [];
            for(var i = 0; i < json.server.client_ip_rules.length; i++) {
                var newclient_ip_rules = {};
                newclient_ip_rules["id"] = json.server.client_ip_rules[i];
                newclient_ip_rules["client_ip_rules"] = json.server.client_ip_rules[i];
                newclient_ip_ruless.push(newclient_ip_rules);
                server_client_ip_rulesrowData.server_client_ip_rules.push(newclient_ip_rules);
            }
            }
          if(json !== undefined && json.server !== undefined && json.server.content_security_policy !== undefined ) {
            setserver_content_security_policy(json.server.content_security_policy);
          }
          var newcredential_service_cache = {};
          if(json !== undefined && json.server !== undefined && json.server.credential_service_cache !== undefined ) {
            if(json !== undefined && json.server !== undefined && json.server.credential_service_cache !== undefined && json.server.credential_service_cache.cache_enabled !== undefined ) {
              setserver_credential_service_cache_cache_enabled(json.server.credential_service_cache.cache_enabled);
            }
            if(json !== undefined && json.server !== undefined && json.server.credential_service_cache !== undefined && json.server.credential_service_cache.cache_size !== undefined ) {
              setserver_credential_service_cache_cache_size(json.server.credential_service_cache.cache_size);
            }
            if(json !== undefined && json.server !== undefined && json.server.credential_service_cache !== undefined && json.server.credential_service_cache.entry_idle_timeout !== undefined ) {
              setserver_credential_service_cache_entry_idle_timeout(json.server.credential_service_cache.entry_idle_timeout);
            }
            if(json !== undefined && json.server !== undefined && json.server.credential_service_cache !== undefined && json.server.credential_service_cache.entry_lifetime !== undefined ) {
              setserver_credential_service_cache_entry_lifetime(json.server.credential_service_cache.entry_lifetime);
            }
            if(json !== undefined && json.server !== undefined && json.server.credential_service_cache !== undefined && json.server.credential_service_cache.login_clear_user !== undefined ) {
              setserver_credential_service_cache_login_clear_user(json.server.credential_service_cache.login_clear_user);
            }
          }
          if(json !== undefined && json.server !== undefined && json.server.enabled_languages !== undefined ) {
            var newenabled_languagess = [];
            for(var i = 0; i < json.server.enabled_languages.length; i++) {
                var newenabled_languages = {};
                newenabled_languages["id"] = json.server.enabled_languages[i];
                newenabled_languages["enabled_languages"] = json.server.enabled_languages[i];
                newenabled_languagess.push(newenabled_languages);
                server_enabled_languagesrowData.server_enabled_languages.push(newenabled_languages);
            }
            }
          var newerror_pages = {};
          if(json !== undefined && json.server !== undefined && json.server.error_pages !== undefined ) {
            if(json !== undefined && json.server !== undefined && json.server.error_pages !== undefined && json.server.error_pages.content !== undefined ) {
              setserver_error_pages_content(json.server.error_pages.content);
            }
            if(json !== undefined && json.server !== undefined && json.server.error_pages !== undefined && json.server.error_pages.type !== undefined ) {
              setserver_error_pages_type(json.server.error_pages.type);
            }
          }
          var newfailover = {};
          if(json !== undefined && json.server !== undefined && json.server.failover !== undefined ) {
            if(json !== undefined && json.server !== undefined && json.server.failover !== undefined && json.server.failover.cookie_name !== undefined ) {
              setserver_failover_cookie_name(json.server.failover.cookie_name);
            }
            if(json !== undefined && json.server !== undefined && json.server.failover !== undefined && json.server.failover.domain_cookie !== undefined ) {
              setserver_failover_domain_cookie(json.server.failover.domain_cookie);
            }
            if(json !== undefined && json.server !== undefined && json.server.failover !== undefined && json.server.failover.key !== undefined ) {
              setserver_failover_key(json.server.failover.key);
            }
          }
          if(json !== undefined && json.server !== undefined && json.server.http2 !== undefined ) {
            setserver_http2(json.server.http2);
          }
          var newlocal_applications = {};
          if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined ) {
            var newazn_decision = {};
            if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.azn_decision !== undefined ) {
              if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.azn_decision !== undefined && json.server.local_applications.azn_decision.max_cache_lifetime !== undefined ) {
                setserver_local_applications_azn_decision_max_cache_lifetime(json.server.local_applications.azn_decision.max_cache_lifetime);
              }
              if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.azn_decision !== undefined && json.server.local_applications.azn_decision.max_cache_size !== undefined ) {
                setserver_local_applications_azn_decision_max_cache_size(json.server.local_applications.azn_decision.max_cache_size);
              }
              if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.azn_decision !== undefined && json.server.local_applications.azn_decision.path_segment !== undefined ) {
                setserver_local_applications_azn_decision_path_segment(json.server.local_applications.azn_decision.path_segment);
              }
            }
            newlocal_applications["azn_decision"] = newazn_decision;
            var newcred_viewer = {};
            if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.cred_viewer !== undefined ) {
              if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.cred_viewer !== undefined && json.server.local_applications.cred_viewer.attributes !== undefined ) {
                var newattributess = [];
                for(var i = 0; i < json.server.local_applications.cred_viewer.attributes.length; i++) {
                    var newattributes = {};
                    newattributes["id"] = json.server.local_applications.cred_viewer.attributes[i];
                    newattributes["attributes"] = json.server.local_applications.cred_viewer.attributes[i];
                    newattributess.push(newattributes);
                    server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes.push(newattributes);
                }
                }
              if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.cred_viewer !== undefined && json.server.local_applications.cred_viewer.enable_html !== undefined ) {
                setserver_local_applications_cred_viewer_enable_html(json.server.local_applications.cred_viewer.enable_html);
              }
              if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.cred_viewer !== undefined && json.server.local_applications.cred_viewer.path_segment !== undefined ) {
                setserver_local_applications_cred_viewer_path_segment(json.server.local_applications.cred_viewer.path_segment);
              }
            }
            newlocal_applications["cred_viewer"] = newcred_viewer;
            var newjwks = {};
            if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.jwks !== undefined ) {
              if(json !== undefined && json.server !== undefined && json.server.local_applications !== undefined && json.server.local_applications.jwks !== undefined && json.server.local_applications.jwks.path_segment !== undefined ) {
                setserver_local_applications_jwks_path_segment(json.server.local_applications.jwks.path_segment);
              }
            }
            newlocal_applications["jwks"] = newjwks;
          }
          var newlocal_pages = {};
          if(json !== undefined && json.server !== undefined && json.server.local_pages !== undefined ) {
            if(json !== undefined && json.server !== undefined && json.server.local_pages !== undefined && json.server.local_pages.content !== undefined ) {
              setserver_local_pages_content(json.server.local_pages.content);
            }
            if(json !== undefined && json.server !== undefined && json.server.local_pages !== undefined && json.server.local_pages.type !== undefined ) {
              setserver_local_pages_type(json.server.local_pages.type);
            }
          }
          var newmanagement_pages = {};
          if(json !== undefined && json.server !== undefined && json.server.management_pages !== undefined ) {
            if(json !== undefined && json.server !== undefined && json.server.management_pages !== undefined && json.server.management_pages.content !== undefined ) {
              setserver_management_pages_content(json.server.management_pages.content);
            }
            if(json !== undefined && json.server !== undefined && json.server.management_pages !== undefined && json.server.management_pages.type !== undefined ) {
              setserver_management_pages_type(json.server.management_pages.type);
            }
          }
          if(json !== undefined && json.server !== undefined && json.server.protocols !== undefined ) {
            var newprotocolss = [];
            for(var i = 0; i < json.server.protocols.length; i++) {
                var newprotocols = {};
                newprotocols["id"] = json.server.protocols[i];
                newprotocols["protocols"] = json.server.protocols[i];
                newprotocolss.push(newprotocols);
                server_protocolsrowData.server_protocols.push(newprotocols);
            }
            }
          var newpublic_assets = {};
          if(json !== undefined && json.server !== undefined && json.server.public_assets !== undefined ) {
            if(json !== undefined && json.server !== undefined && json.server.public_assets !== undefined && json.server.public_assets.content !== undefined ) {
              setserver_public_assets_content(json.server.public_assets.content);
            }
            if(json !== undefined && json.server !== undefined && json.server.public_assets !== undefined && json.server.public_assets.path_segment !== undefined ) {
              setserver_public_assets_path_segment(json.server.public_assets.path_segment);
            }
            if(json !== undefined && json.server !== undefined && json.server.public_assets !== undefined && json.server.public_assets.type !== undefined ) {
              setserver_public_assets_type(json.server.public_assets.type);
            }
          }
          var newrate_limiting = {};
          if(json !== undefined && json.server !== undefined && json.server.rate_limiting !== undefined ) {
            if(json !== undefined && json.server !== undefined && json.server.rate_limiting !== undefined && json.server.rate_limiting.cache_size !== undefined ) {
              setserver_rate_limiting_cache_size(json.server.rate_limiting.cache_size);
            }
            var newredis = {};
            if(json !== undefined && json.server !== undefined && json.server.rate_limiting !== undefined && json.server.rate_limiting.redis !== undefined ) {
              if(json !== undefined && json.server !== undefined && json.server.rate_limiting !== undefined && json.server.rate_limiting.redis !== undefined && json.server.rate_limiting.redis.collection_name !== undefined ) {
                setserver_rate_limiting_redis_collection_name(json.server.rate_limiting.redis.collection_name);
              }
              if(json !== undefined && json.server !== undefined && json.server.rate_limiting !== undefined && json.server.rate_limiting.redis !== undefined && json.server.rate_limiting.redis.sync_window !== undefined ) {
                setserver_rate_limiting_redis_sync_window(json.server.rate_limiting.redis.sync_window);
              }
            }
            newrate_limiting["redis"] = newredis;
            if(json !== undefined && json.server !== undefined && json.server.rate_limiting !== undefined && json.server.rate_limiting.response_headers !== undefined ) {
              setserver_rate_limiting_response_headers(json.server.rate_limiting.response_headers);
            }
          }
          if(json !== undefined && json.server !== undefined && json.server.response_headers !== undefined ) {
            var newresponse_headerss = [];
            for(var i = 0; i < json.server.response_headers.length; i++) {
              var newItem = {};
              var tempId = ((json.server.response_headers[i].header)?json.server.response_headers[i].header:"");
              newItem["id"] = tempId;
              newItem["attribute"] = json.server.response_headers[i].attribute;
              newItem["header"] = json.server.response_headers[i].header;
              newItem["macro"] = json.server.response_headers[i].macro;
              newItem["text"] = json.server.response_headers[i].text;
              server_response_headersrowData.server_response_headers.push(newItem);
            }
            }
          var newsession = {};
          if(json !== undefined && json.server !== undefined && json.server.session !== undefined ) {
            if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.cookie_name !== undefined ) {
              setserver_session_cookie_name(json.server.session.cookie_name);
            }
            if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.inactive_timeout !== undefined ) {
              setserver_session_inactive_timeout(json.server.session.inactive_timeout);
            }
            if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.max_sessions !== undefined ) {
              setserver_session_max_sessions(json.server.session.max_sessions);
            }
            if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.permit_user_switching !== undefined ) {
              setserver_session_permit_user_switching(json.server.session.permit_user_switching);
            }
            var newreauth = {};
            if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.reauth !== undefined ) {
              if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.reauth !== undefined && json.server.session.reauth.login_time_window !== undefined ) {
                setserver_session_reauth_login_time_window(json.server.session.reauth.login_time_window);
              }
            }
            newsession["reauth"] = newreauth;
            var newredis = {};
            if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.redis !== undefined ) {
              if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.redis !== undefined && json.server.session.redis.client_list_cache_lifetime !== undefined ) {
                setserver_session_redis_client_list_cache_lifetime(json.server.session.redis.client_list_cache_lifetime);
              }
              var newconcurrent_sessions = {};
              if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.redis !== undefined && json.server.session.redis.concurrent_sessions !== undefined ) {
                if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.redis !== undefined && json.server.session.redis.concurrent_sessions !== undefined && json.server.session.redis.concurrent_sessions.enabled !== undefined ) {
                  setserver_session_redis_concurrent_sessions_enabled(json.server.session.redis.concurrent_sessions.enabled);
                }
                if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.redis !== undefined && json.server.session.redis.concurrent_sessions !== undefined && json.server.session.redis.concurrent_sessions.max_user_sessions !== undefined ) {
                  setserver_session_redis_concurrent_sessions_max_user_sessions(json.server.session.redis.concurrent_sessions.max_user_sessions);
                }
                if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.redis !== undefined && json.server.session.redis.concurrent_sessions !== undefined && json.server.session.redis.concurrent_sessions.prompt_for_displacement !== undefined ) {
                  setserver_session_redis_concurrent_sessions_prompt_for_displacement(json.server.session.redis.concurrent_sessions.prompt_for_displacement);
                }
                if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.redis !== undefined && json.server.session.redis.concurrent_sessions !== undefined && json.server.session.redis.concurrent_sessions.user_identity_attribute_name !== undefined ) {
                  setserver_session_redis_concurrent_sessions_user_identity_attribute_name(json.server.session.redis.concurrent_sessions.user_identity_attribute_name);
                }
              }
              newredis["concurrent_sessions"] = newconcurrent_sessions;
              if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.redis !== undefined && json.server.session.redis.enabled !== undefined ) {
                setserver_session_redis_enabled(json.server.session.redis.enabled);
              }
            }
            newsession["redis"] = newredis;
            if(json !== undefined && json.server !== undefined && json.server.session !== undefined && json.server.session.timeout !== undefined ) {
              setserver_session_timeout(json.server.session.timeout);
            }
          }
          var newssl = {};
          if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined ) {
            var newapplications = {};
            if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.applications !== undefined ) {
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.applications !== undefined && json.server.ssl.applications.tlsv10 !== undefined ) {
                setserver_ssl_applications_tlsv10(json.server.ssl.applications.tlsv10);
              }
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.applications !== undefined && json.server.ssl.applications.tlsv11 !== undefined ) {
                setserver_ssl_applications_tlsv11(json.server.ssl.applications.tlsv11);
              }
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.applications !== undefined && json.server.ssl.applications.tlsv12 !== undefined ) {
                setserver_ssl_applications_tlsv12(json.server.ssl.applications.tlsv12);
              }
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.applications !== undefined && json.server.ssl.applications.tlsv13 !== undefined ) {
                setserver_ssl_applications_tlsv13(json.server.ssl.applications.tlsv13);
              }
            }
            newssl["applications"] = newapplications;
            if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.ciphers !== undefined ) {
              var newcipherss = [];
              for(var i = 0; i < json.server.ssl.ciphers.length; i++) {
                  var newciphers = {};
                  newciphers["id"] = json.server.ssl.ciphers[i];
                  newciphers["ciphers"] = json.server.ssl.ciphers[i];
                  newcipherss.push(newciphers);
                  server_ssl_ciphersrowData.server_ssl_ciphers.push(newciphers);
              }
              }
            var newfront_end = {};
            if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.front_end !== undefined ) {
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.front_end !== undefined && json.server.ssl.front_end.certificate !== undefined ) {
                var newcertificates = [];
                for(var i = 0; i < json.server.ssl.front_end.certificate.length; i++) {
                    var newcertificate = {};
                    newcertificate["id"] = json.server.ssl.front_end.certificate[i];
                    newcertificate["certificate"] = json.server.ssl.front_end.certificate[i];
                    newcertificates.push(newcertificate);
                    server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate.push(newcertificate);
                }
                }
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.front_end !== undefined && json.server.ssl.front_end.sni !== undefined ) {
                var newsnis = [];
                for(var i = 0; i < json.server.ssl.front_end.sni.length; i++) {
                  var newfront_end = {};
                  if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.front_end !== undefined && json.server.ssl.front_end.sni[i] !== undefined && json.server.ssl.front_end.sni[i].certificate !== undefined ) {
                    var newcertificates = [];
                    for(var i2 = 0; i2 < json.server.ssl.front_end.sni[i].certificate.length; i2++) {
                        var newcertificate = {};
                        newcertificate["id"] = json.server.ssl.front_end.sni[i].certificate[i2];
                        newcertificate["certificate"] = json.server.ssl.front_end.sni[i].certificate[i2];
                        newcertificates.push(newcertificate);
                    }
                    newfront_end["certificate"] = newcertificates;
                    }
                  var tempId = ((json.server.ssl.front_end.sni[i].hostname)?json.server.ssl.front_end.sni[i].hostname:"");
                  newfront_end["id"] = tempId;
                  newfront_end["hostname"] = json.server.ssl.front_end.sni[i].hostname;
                }
                server_ssl_front_end_snirowData.server_ssl_front_end_sni.push(newfront_end);
                }
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.front_end !== undefined && json.server.ssl.front_end.tlsv10 !== undefined ) {
                setserver_ssl_front_end_tlsv10(json.server.ssl.front_end.tlsv10);
              }
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.front_end !== undefined && json.server.ssl.front_end.tlsv11 !== undefined ) {
                setserver_ssl_front_end_tlsv11(json.server.ssl.front_end.tlsv11);
              }
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.front_end !== undefined && json.server.ssl.front_end.tlsv12 !== undefined ) {
                setserver_ssl_front_end_tlsv12(json.server.ssl.front_end.tlsv12);
              }
              if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.front_end !== undefined && json.server.ssl.front_end.tlsv13 !== undefined ) {
                setserver_ssl_front_end_tlsv13(json.server.ssl.front_end.tlsv13);
              }
            }
            newssl["front_end"] = newfront_end;
            if(json !== undefined && json.server !== undefined && json.server.ssl !== undefined && json.server.ssl.trust_certificates !== undefined ) {
              var newtrust_certificatess = [];
              for(var i = 0; i < json.server.ssl.trust_certificates.length; i++) {
                  var newtrust_certificates = {};
                  newtrust_certificates["id"] = json.server.ssl.trust_certificates[i];
                  newtrust_certificates["trust_certificates"] = json.server.ssl.trust_certificates[i];
                  newtrust_certificatess.push(newtrust_certificates);
                  server_ssl_trust_certificatesrowData.server_ssl_trust_certificates.push(newtrust_certificates);
              }
              }
          }
          var newwebsocket = {};
          if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined ) {
            var newtimeouts = {};
            if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.timeouts !== undefined ) {
              var newapplications = {};
              if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.timeouts !== undefined && json.server.websocket.timeouts.applications !== undefined ) {
                if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.timeouts !== undefined && json.server.websocket.timeouts.applications !== undefined && json.server.websocket.timeouts.applications.read !== undefined ) {
                  setserver_websocket_timeouts_applications_read(json.server.websocket.timeouts.applications.read);
                }
                if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.timeouts !== undefined && json.server.websocket.timeouts.applications !== undefined && json.server.websocket.timeouts.applications.write !== undefined ) {
                  setserver_websocket_timeouts_applications_write(json.server.websocket.timeouts.applications.write);
                }
              }
              newtimeouts["applications"] = newapplications;
              var newfront_end = {};
              if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.timeouts !== undefined && json.server.websocket.timeouts.front_end !== undefined ) {
                if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.timeouts !== undefined && json.server.websocket.timeouts.front_end !== undefined && json.server.websocket.timeouts.front_end.read !== undefined ) {
                  setserver_websocket_timeouts_front_end_read(json.server.websocket.timeouts.front_end.read);
                }
                if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.timeouts !== undefined && json.server.websocket.timeouts.front_end !== undefined && json.server.websocket.timeouts.front_end.write !== undefined ) {
                  setserver_websocket_timeouts_front_end_write(json.server.websocket.timeouts.front_end.write);
                }
              }
              newtimeouts["front_end"] = newfront_end;
            }
            newwebsocket["timeouts"] = newtimeouts;
            var newworker_threads = {};
            if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.worker_threads !== undefined ) {
              if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.worker_threads !== undefined && json.server.websocket.worker_threads.idle !== undefined ) {
                setserver_websocket_worker_threads_idle(json.server.websocket.worker_threads.idle);
              }
              if(json !== undefined && json.server !== undefined && json.server.websocket !== undefined && json.server.websocket.worker_threads !== undefined && json.server.websocket.worker_threads.max !== undefined ) {
                setserver_websocket_worker_threads_max(json.server.websocket.worker_threads.max);
              }
            }
            newwebsocket["worker_threads"] = newworker_threads;
          }
          if(json !== undefined && json.server !== undefined && json.server.worker_threads !== undefined ) {
            setserver_worker_threads(json.server.worker_threads);
          }
        }
    };



    const setDataMain = (functionName, data) => {
      if(functionName && data) {
        eval(functionName)(data);
      }
    };

    return (
        <div className="bx--grid--no-gutter bx--grid--full-width landing-page">
          <div className="bx--row landing-page__banner" style={{paddingBottom:"3rem"}}>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h1 className="landing-page__heading">
                Server
              </h1>
            </div>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h4 className="landing-page__desc" style={{marginTop:"30px"}}>The `server` node defines configuration for the gateway daemon front-end.
</h4>
            </div>            <div id="warning_div" className="bx--col-lg-13" style={{display:'none', color:'red', position:'absolute', bottom:'0', marginBottom: '10px'}}></div>
          </div>
          <div className="bx--row landing-page__r2">
            <div className="bx--col bx--no-gutter">
              <div id="serverPage" className="bx--col">
                <br/><br/><br/>
            <Tabs id={"server_tab" + idPrefix} defaultTab={"General_tab" + idPrefix} vertical className="vertical-tabs" style={{overflow:'auto'}}>
              <TabList>
                <Tab tabFor={"General_tab" + idPrefix}>General</Tab>
                <Tab tabFor={"client_ip_rules_tab" + idPrefix}>Client IP Rules</Tab>
                <Tab tabFor={"credential_service_cache_tab" + idPrefix}>Credential Service Cache</Tab>
                <Tab tabFor={"enabled_languages_tab" + idPrefix}>Enabled Languages</Tab>
                <Tab tabFor={"error_pages_tab" + idPrefix}>Error Pages</Tab>
                <Tab tabFor={"failover_tab" + idPrefix}>Failover</Tab>
                <Tab tabFor={"local_applications_tab" + idPrefix}>Local Applications</Tab>
                <Tab tabFor={"local_pages_tab" + idPrefix}>Local Pages</Tab>
                <Tab tabFor={"management_pages_tab" + idPrefix}>Management Pages</Tab>
                <Tab tabFor={"protocols_tab" + idPrefix}>Protocols</Tab>
                <Tab tabFor={"public_assets_tab" + idPrefix}>Public Assets</Tab>
                <Tab tabFor={"rate_limiting_tab" + idPrefix}>Rate Limiting</Tab>
                <Tab tabFor={"response_headers_tab" + idPrefix}>Response Headers</Tab>
                <Tab tabFor={"ssl_tab" + idPrefix}>SSL</Tab>
                <Tab tabFor={"session_tab" + idPrefix}>Session</Tab>
                <Tab tabFor={"websocket_tab" + idPrefix}>WebSocket</Tab>
              </TabList>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"protocols_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Protocols Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"server_protocols_tooltip_id" + idPrefix} >Protocols</h3><hr/>
</div>
          <ReactTooltip id={"server_protocols_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>Specifies the protocols which will be supported by the server. The server will listen on a different port for each protocol: `http/8080` and `https/8443`. If no protocols are specified, the server will listen for https requests only.<br/><br/>Additionally, the server can be configured to expect the PROXY Protocol header by using the `*_proxy` values.<br/><br/>Note that if the proxy protocol is enabled for a given protocol, all traffic for that protocol will be expected to contain the PROXY protocol headers. That is, the following entries are exclusive:<br/> - `http` and `http_proxy`<br/> - `https` and `https_proxy`<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>protocol    </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Port </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Description</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>http        </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 8080 </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> HTTP</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>https       </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 8443 </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> HTTPS</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>http_proxy  </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 8080 </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> HTTP with Proxy Protocol</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>https_proxy </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 8443 </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> HTTPS with Proxy Protocol</td></tr></tbody></table></div></ReactTooltip>

                <div id={"server_protocolsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem server_div" + idPrefix}>
                    <DataTable id={"server_protocolsTable" + idPrefix} isSortable
                        headers={server_protocolsheaderData}
                        rows={server_protocolsrowData.server_protocols}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {server_protocolshandleAdd(idPrefix, [setserver_protocols_protocols('https'),    setserver_protocols_protocols_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServerprotocolsDeleteModal row={row} loadGrid={server_protocolsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServerprotocolsEdit  data={server_protocolsrowData.server_protocols} setData={setDataMain} row={row} loadGrid={server_protocolsloadGrid} dataLoad={dataLoad} editing={true} name={"server_protocols"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_protocols_protocols={updateserver_protocols_protocols} server_protocols_protocols={server_protocols_protocols}
            server_protocols_protocols_valid={server_protocols_protocols_valid}
            server_protocols_protocols_invalid_text={server_protocols_protocols_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"local_applications_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Local Applications Settings</h2><hr/>
                  Specifies the configuration for any embedded applications.
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Authorization Decision</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_local_applications_azn_decision_max_cache_lifetime} id={"server_local_applications_azn_decision_max_cache_lifetime_id" + idPrefix}  data-tooltip-id={"server_local_applications_azn_decision_max_cache_lifetime_tooltip_id" + idPrefix}  min={1}  label="Max Cache Lifetime" onChange={(evt) => { updateserver_local_applications_azn_decision_max_cache_lifetime(evt); handleChange(); }}/>
          <ReactTooltip id={"server_local_applications_azn_decision_max_cache_lifetime_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum lifetime, in seconds, of an entry in the cache.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_local_applications_azn_decision_max_cache_size} id={"server_local_applications_azn_decision_max_cache_size_id" + idPrefix}  data-tooltip-id={"server_local_applications_azn_decision_max_cache_size_tooltip_id" + idPrefix}  min={1}  label="Max Cache Size" onChange={(evt) => { updateserver_local_applications_azn_decision_max_cache_size(evt); handleChange(); }}/>
          <ReactTooltip id={"server_local_applications_azn_decision_max_cache_size_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum number of credentials which can be cached. If the addition of a new credential will exceed this maximum cache size a least-recently-used algorithm will be used to remove an older entry, making room for the new credential.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_local_applications_azn_decision_path_segment}  id={"server_local_applications_azn_decision_path_segment_id" + idPrefix}  data-tooltip-id={"server_local_applications_azn_decision_path_segment_tooltip_id" + idPrefix}  labelText="Path Segment" onChange={(evt) => { updateserver_local_applications_azn_decision_path_segment(evt); handleChange(); }}/>
          <ReactTooltip id={"server_local_applications_azn_decision_path_segment_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The path at which the application will be available. The path should be a simple path segment (i.e. should not contain a `/` character).<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Credential Viewer</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"server_local_applications_cred_viewer_attributes_tooltip_id" + idPrefix} >Attributes</h3><hr/>
</div>
          <ReactTooltip id={"server_local_applications_cred_viewer_attributes_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The rules which define the credential attributes which will be included in the response data.  See the  Attributes Format table for a description of the expected format.<br/></div></ReactTooltip>

                <div id={"server_local_applications_cred_viewer_attributesTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem server_div" + idPrefix}>
                    <DataTable id={"server_local_applications_cred_viewer_attributesTable" + idPrefix} isSortable
                        headers={server_local_applications_cred_viewer_attributesheaderData}
                        rows={server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {server_local_applications_cred_viewer_attributeshandleAdd(idPrefix, [setserver_local_applications_cred_viewer_attributes_attributes(''),    setserver_local_applications_cred_viewer_attributes_attributes_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServerlocalApplicationscredViewerattributesDeleteModal row={row} loadGrid={server_local_applications_cred_viewer_attributesloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServerlocalApplicationscredViewerattributesEdit  data={server_local_applications_cred_viewer_attributesrowData.server_local_applications_cred_viewer_attributes} setData={setDataMain} row={row} loadGrid={server_local_applications_cred_viewer_attributesloadGrid} dataLoad={dataLoad} editing={true} name={"server_local_applications_cred_viewer_attributes"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_local_applications_cred_viewer_attributes_attributes={updateserver_local_applications_cred_viewer_attributes_attributes} server_local_applications_cred_viewer_attributes_attributes={server_local_applications_cred_viewer_attributes_attributes}
            server_local_applications_cred_viewer_attributes_attributes_valid={server_local_applications_cred_viewer_attributes_attributes_valid}
            server_local_applications_cred_viewer_attributes_attributes_invalid_text={server_local_applications_cred_viewer_attributes_attributes_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_local_applications_cred_viewer_enable_html} id={"server_local_applications_cred_viewer_enable_html_id" + idPrefix}  data-tooltip-id={"server_local_applications_cred_viewer_enable_html_tooltip_id" + idPrefix}  labelText="Enable HTML" onChange={(evt) => { updateserver_local_applications_cred_viewer_enable_html(evt); handleChange(); }}/>
          <ReactTooltip id={"server_local_applications_cred_viewer_enable_html_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean flag indicating whether or not the embedded HTML page which can render the JSON data is enabled.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_local_applications_cred_viewer_path_segment}  id={"server_local_applications_cred_viewer_path_segment_id" + idPrefix}  data-tooltip-id={"server_local_applications_cred_viewer_path_segment_tooltip_id" + idPrefix}  labelText="Path Segment" onChange={(evt) => { updateserver_local_applications_cred_viewer_path_segment(evt); handleChange(); }}/>
          <ReactTooltip id={"server_local_applications_cred_viewer_path_segment_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The path at which the application will be available. The path should be a simple path segment (i.e. should not contain a `/` character).<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>JWKS</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_local_applications_jwks_path_segment}  id={"server_local_applications_jwks_path_segment_id" + idPrefix}  data-tooltip-id={"server_local_applications_jwks_path_segment_tooltip_id" + idPrefix}  labelText="Path Segment" onChange={(evt) => { updateserver_local_applications_jwks_path_segment(evt); handleChange(); }}/>
          <ReactTooltip id={"server_local_applications_jwks_path_segment_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The path at which the application will be available. The path should be a simple path segment (i.e. should not contain a `/` character).<br/></div></ReactTooltip>
        </div>

                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"error_pages_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Error Pages Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="This entry overloads the server generated error response pages">
                    <p>This entry overloads the server generated error response pages.<br/>This entry must be either a zip file or a path which is relative to the `/var/iag/config` directory of the container.<br/>The provided contents will completely replace the default set of error pages served by the IAG.<br/><br/>The pages which are provided should conform to the directory structure and file name syntax explained below.<br/>The directory structure is:<br/><br/>`&lt;language_code&gt;/&lt;error_code&gt;.&lt;response_code&gt;.&lt;mime_type&gt;`<br/><br/><h4># language_code</h4><br/><br/>`&lt;language_code&gt;` is a directory containing all the pages which will be presented to clients which prefer that language.<br/>If you do not wish to ever return pages to clients in a specific language, the corresponding language_code directory can be omitted.<br/>The reverse proxy will use the container language (set via the `LANG` environment variable) if a page is requested in a language which is not provided.<br/><br/>For example, to only ever return error pages in English and French, include only the `C` and `fr` directories in the zip file and run the container with `LANG=C`.<br/>When a language other than English or French is requested, the page will fall back to `LANG` and be returned in English.<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}> `language_code` </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Language              </th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> pt              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Brazilian Portuguese  </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> cs              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Czech                 </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> zh_CN           </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Chinese (Simplified)  </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> zh_TW           </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Chinese (Traditional) </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> C               </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> English               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> fr              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> French                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> de              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> German                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> hu              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Hungarian             </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> it              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Italian               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ja              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Japanese              </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ko              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Korean                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> pl              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Polish                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> es              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Spanish               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ru              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Russian               </td></tr></tbody></table><br/><h4># error_code</h4><br/><br/>`&lt;error_code&gt;` corresponds to a specific error code in hexadecimal format.<br/>The special error code of `default` can also be used to configure a default page which is used for any error codes which do not have a specific page.<br/><br/><h4># response_code</h4><br/><br/>`&lt;response_code&gt;` can be used to control the HTTP status code which the reverse proxy presents when it serves the page.<br/>This part of filename is optional and the default value will be used if no response_code is indicated.<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}> `error_code` </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Default `response_code` </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Description             </th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 38cf0420     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 301                     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Moved Permanently       </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 38cf0421     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 302                     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Moved Temporarily       </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 38cf0427     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 403                     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Forbidden               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 38cf0428     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 404                     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Not Found               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 38cf04c6     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 500                     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Server Not Responding   </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 38cf04d7     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 500                     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Server Not Responding   </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 38cf08cc     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 403                     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Forbidden (Time based)  </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> default      </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 400                     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Any other error code    </td></tr></tbody></table><br/><h4># mime_type</h4><br/><br/>`&lt;mime_type&gt;` corresponds to the mime sub-type which this page will be returned for.<br/>For example, if a client request contains the `accept` header `text/html`, `html` is the mime sub-type and should be used for the file extension.<br/>If an `accept` header is not present, the reverse proxy will also consider the `content-type` header.<br/><br/><h4># Examples</h4><br/><br/>For example, to customise:<br/><br/>- the `forbidden` error response (error code `38cf0427`)<br/>- for Korean language<br/>- to return HTTP status 500<br/>- for clients expecting `application/json`<br/><br/>Create the following file in the zip file of error response pages:<br/><br/>`ko/38cf0427.500.json`<br/><br/><h4># Defaults</h4><br/><br/>If no value is specified here, the default set of pages will be used.<br/>The default set of pages, `error_pages.zip`, can be downloaded from GitHub (https://github.com/IBM-Security/ibm-application-gateway-resources/tree/master/pages) and used as a starting point for creating custom error pages.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_error_pages_content}  id={"server_error_pages_content_id" + idPrefix}  data-tooltip-id={"server_error_pages_content_tooltip_id" + idPrefix}  labelText="Content" onChange={(evt) => { updateserver_error_pages_content(evt); handleChange(); }}/>
          <ReactTooltip id={"server_error_pages_content_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The content which will be used for the error pages.  The content can either be the name of a directory, relative to the `/var/iag/config` directory of the container, or a zip file.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
                <Select
                  value={server_error_pages_type}
                   id={"server_error_pages_type_id" + idPrefix}
 data-tooltip-id={"server_error_pages_type_tooltip_id" + idPrefix}                   labelText="Type"
                  onChange={(evt) => { updateserver_error_pages_type(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="zip" value="zip" />
                  <SelectItem text="path" value="path" />
                </Select>
          <ReactTooltip id={"server_error_pages_type_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The type of content which is being supplied.  Either a zip file or a directory name.<br/></div></ReactTooltip>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"response_headers_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Response Headers Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"server_response_headers_tooltip_id" + idPrefix} >Response Headers</h3><hr/>
</div>
          <ReactTooltip id={"server_response_headers_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This entry can be used to set HTTP headers which are always present in all responses which are returned to clients.<br/>For each entry, only one of `macro`, `attribute` or `text` can be specified.<br/></div></ReactTooltip>

                <div id={"server_response_headersTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem server_div" + idPrefix}>
                    <DataTable id={"server_response_headersTable" + idPrefix} isSortable
                        headers={server_response_headersheaderData}
                        rows={server_response_headersrowData.server_response_headers}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {server_response_headershandleAdd(idPrefix, [setserver_response_headers_attribute(''),    setserver_response_headers_header(''),    setserver_response_headers_header_valid(true),    setserver_response_headers_macro(''),    setserver_response_headers_text(''),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServerresponseHeadersDeleteModal row={row} loadGrid={server_response_headersloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServerresponseHeadersEdit  data={server_response_headersrowData.server_response_headers} setData={setDataMain} row={row} loadGrid={server_response_headersloadGrid} dataLoad={dataLoad} editing={true} name={"server_response_headers"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_response_headers_attribute={updateserver_response_headers_attribute} server_response_headers_attribute={server_response_headers_attribute}
            updateserver_response_headers_header={updateserver_response_headers_header} server_response_headers_header={server_response_headers_header}
            server_response_headers_header_valid={server_response_headers_header_valid}
            server_response_headers_header_invalid_text={server_response_headers_header_invalid_text}
            updateserver_response_headers_macro={updateserver_response_headers_macro} server_response_headers_macro={server_response_headers_macro}
            updateserver_response_headers_text={updateserver_response_headers_text} server_response_headers_text={server_response_headers_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"ssl_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>SSL Settings</h2><hr/>
                  Specifies the secure configuration for the gateway server.
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Applications</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_ssl_applications_tlsv10} id={"server_ssl_applications_tlsv10_id" + idPrefix}  data-tooltip-id={"server_ssl_applications_tlsv10_tooltip_id" + idPrefix}  labelText="TLS 1.0" onChange={(evt) => { updateserver_ssl_applications_tlsv10(evt); handleChange(); }}/>
          <ReactTooltip id={"server_ssl_applications_tlsv10_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether or not TLS v1.0 is enabled.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_ssl_applications_tlsv11} id={"server_ssl_applications_tlsv11_id" + idPrefix}  data-tooltip-id={"server_ssl_applications_tlsv11_tooltip_id" + idPrefix}  labelText="TLS 1.1" onChange={(evt) => { updateserver_ssl_applications_tlsv11(evt); handleChange(); }}/>
          <ReactTooltip id={"server_ssl_applications_tlsv11_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether or not TLS v1.1 is enabled.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_ssl_applications_tlsv12} id={"server_ssl_applications_tlsv12_id" + idPrefix}  data-tooltip-id={"server_ssl_applications_tlsv12_tooltip_id" + idPrefix}  labelText="TLS 1.2" onChange={(evt) => { updateserver_ssl_applications_tlsv12(evt); handleChange(); }}/>
          <ReactTooltip id={"server_ssl_applications_tlsv12_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether or not TLS v1.2 is enabled.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_ssl_applications_tlsv13} id={"server_ssl_applications_tlsv13_id" + idPrefix}  data-tooltip-id={"server_ssl_applications_tlsv13_tooltip_id" + idPrefix}  labelText="TLS 1.3" onChange={(evt) => { updateserver_ssl_applications_tlsv13(evt); handleChange(); }}/>
          <ReactTooltip id={"server_ssl_applications_tlsv13_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether or not TLS v1.3 is enabled.<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"server_ssl_ciphers_tooltip_id" + idPrefix} >Ciphers</h3><hr/>
</div>
          <ReactTooltip id={"server_ssl_ciphers_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>Specifies the ciphers and cipher suites which will be permitted for all secure communications.<br/><br/>The following tables show the list of available ciphers.<br/><br/><h4> Supported Cipher Names</h4><br/><br/>Name |<br/>---- |<br/>TLS_DHE_PSK_WITH_AES_128_CCM_8 |<br/>TLS_DHE_PSK_WITH_AES_128_CCM |<br/>TLS_DHE_PSK_WITH_AES_256_CCM_8 |<br/>TLS_DHE_PSK_WITH_AES_256_CCM |<br/>TLS_DHE_RSA_WITH_AES_128_CCM_8 |<br/>TLS_DHE_RSA_WITH_AES_128_CCM |<br/>TLS_DHE_RSA_WITH_AES_128_GCM_SHA256 |<br/>TLS_DHE_RSA_WITH_AES_256_CCM_8 |<br/>TLS_DHE_RSA_WITH_AES_256_CCM |<br/>TLS_DHE_RSA_WITH_AES_256_GCM_SHA384 |<br/>TLS_ECDHE_ECDSA_WITH_3DES_EDE_CBC_SHA |<br/>TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA256 |<br/>TLS_ECDHE_ECDSA_WITH_AES_128_CBC_SHA |<br/>TLS_ECDHE_ECDSA_WITH_AES_128_CCM_8 |<br/>TLS_ECDHE_ECDSA_WITH_AES_128_GCM_SHA256 |<br/>TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA384 |<br/>TLS_ECDHE_ECDSA_WITH_AES_256_CBC_SHA |<br/>TLS_ECDHE_ECDSA_WITH_AES_256_GCM_SHA384 |<br/>TLS_ECDHE_ECDSA_WITH_RC4_128_SHA |<br/>TLS_ECDHE_RSA_WITH_3DES_EDE_CBC_SHA |<br/>TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA256 |<br/>TLS_ECDHE_RSA_WITH_AES_128_CBC_SHA |<br/>TLS_ECDHE_RSA_WITH_AES_128_GCM_SHA256 |<br/>TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA384 |<br/>TLS_ECDHE_RSA_WITH_AES_256_CBC_SHA |<br/>TLS_ECDHE_RSA_WITH_AES_256_GCM_SHA384 |<br/>TLS_ECDHE_RSA_WITH_RC4_128_SHA |<br/>TLS_PSK_WITH_AES_128_CCM_8 |<br/>TLS_PSK_WITH_AES_128_CCM |<br/>TLS_PSK_WITH_AES_256_CCM_8 |<br/>TLS_PSK_WITH_AES_256_CCM |<br/>TLS_RSA_EXPORT1024_WITH_DES_CBC_SHA |<br/>TLS_RSA_EXPORT1024_WITH_RC4_56_SHA |<br/>TLS_RSA_EXPORT_WITH_RC2_CBC_40_MD5 |<br/>TLS_RSA_EXPORT_WITH_RC4_40_MD5 |<br/>TLS_RSA_WITH_3DES_EDE_CBC_SHA |<br/>TLS_RSA_WITH_AES_128_CBC_SHA256 |<br/>TLS_RSA_WITH_AES_128_CBC_SHA |<br/>TLS_RSA_WITH_AES_128_CCM_8 |<br/>TLS_RSA_WITH_AES_128_CCM |<br/>TLS_RSA_WITH_AES_128_GCM_SHA256 |<br/>TLS_RSA_WITH_AES_256_CBC_SHA256 |<br/>TLS_RSA_WITH_AES_256_CBC_SHA |<br/>TLS_RSA_WITH_AES_256_CCM_8 |<br/>TLS_RSA_WITH_AES_256_CCM |<br/>TLS_RSA_WITH_AES_256_GCM_SHA384 |<br/>TLS_RSA_WITH_DES_CBC_SHA |<br/>TLS_RSA_WITH_NULL_MD5 |<br/>TLS_RSA_WITH_NULL_NULL |<br/>TLS_RSA_WITH_NULL_SHA |<br/>TLS_RSA_WITH_RC4_128_MD5 |<br/>TLS_RSA_WITH_RC4_128_SHA |<br/>TLS_RSA_WITH_NULL_SHA256 |<br/>TLS_ECDHE_ECDSA_WITH_NULL_SHA |<br/>TLS_ECDHE_RSA_WITH_NULL_SHA |<br/><br/><h4> Supported TLSv1.3 Cipher Names</h4><br/><br/>Name |<br/>---- |<br/>TLS_AES_128_GCM_SHA256 |<br/>TLS_AES_256_GCM_SHA384 |<br/>TLS_CHACHA20_POLY1305_SHA256 |<br/>TLS_AES_128_CCM_SHA256 |<br/>TLS_AES_128_CCM_8_SHA256 |<br/></div></ReactTooltip>

                <div id={"server_ssl_ciphersTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem server_div" + idPrefix}>
                    <DataTable id={"server_ssl_ciphersTable" + idPrefix} isSortable
                        headers={server_ssl_ciphersheaderData}
                        rows={server_ssl_ciphersrowData.server_ssl_ciphers}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {server_ssl_ciphershandleAdd(idPrefix, [setserver_ssl_ciphers_ciphers(''),    setserver_ssl_ciphers_ciphers_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServersslciphersDeleteModal row={row} loadGrid={server_ssl_ciphersloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServersslciphersEdit  data={server_ssl_ciphersrowData.server_ssl_ciphers} setData={setDataMain} row={row} loadGrid={server_ssl_ciphersloadGrid} dataLoad={dataLoad} editing={true} name={"server_ssl_ciphers"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_ssl_ciphers_ciphers={updateserver_ssl_ciphers_ciphers} server_ssl_ciphers_ciphers={server_ssl_ciphers_ciphers}
            server_ssl_ciphers_ciphers_valid={server_ssl_ciphers_ciphers_valid}
            server_ssl_ciphers_ciphers_invalid_text={server_ssl_ciphers_ciphers_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Front End</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"server_ssl_front_end_certificate_tooltip_id" + idPrefix} >Certificate</h3><hr/>
</div>
          <ReactTooltip id={"server_ssl_front_end_certificate_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>PEM based personal certificate files which will be used when communicating with the client.  These certificate files should include the private key, a certificate signed with the private key, and the signer certificate or signer certificate chain (if required).<br/>If a certificate is not provided, the gateway will generate a self-signed certificate during bootstrapping.<br/></div></ReactTooltip>

                <div id={"server_ssl_front_end_certificateTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem server_div" + idPrefix}>
                    <DataTable id={"server_ssl_front_end_certificateTable" + idPrefix} isSortable
                        headers={server_ssl_front_end_certificateheaderData}
                        rows={server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {server_ssl_front_end_certificatehandleAdd(idPrefix, [setserver_ssl_front_end_certificate_certificate(''),    setserver_ssl_front_end_certificate_certificate_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServersslfrontEndcertificateDeleteModal row={row} loadGrid={server_ssl_front_end_certificateloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServersslfrontEndcertificateEdit  data={server_ssl_front_end_certificaterowData.server_ssl_front_end_certificate} setData={setDataMain} row={row} loadGrid={server_ssl_front_end_certificateloadGrid} dataLoad={dataLoad} editing={true} name={"server_ssl_front_end_certificate"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_ssl_front_end_certificate_certificate={updateserver_ssl_front_end_certificate_certificate} server_ssl_front_end_certificate_certificate={server_ssl_front_end_certificate_certificate}
            server_ssl_front_end_certificate_certificate_valid={server_ssl_front_end_certificate_certificate_valid}
            server_ssl_front_end_certificate_certificate_invalid_text={server_ssl_front_end_certificate_certificate_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"server_ssl_front_end_sni_tooltip_id" + idPrefix} >SNI</h3><hr/>
</div>
          <ReactTooltip id={"server_ssl_front_end_sni_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Specifies a list of SNI certificate to hostname mappings for the front end.<br/></div></ReactTooltip>

                <div id={"server_ssl_front_end_sniTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem server_div" + idPrefix}>
                    <DataTable id={"server_ssl_front_end_sniTable" + idPrefix} isSortable
                        headers={server_ssl_front_end_sniheaderData}
                        rows={server_ssl_front_end_snirowData.server_ssl_front_end_sni}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {server_ssl_front_end_snihandleAdd(idPrefix, [setserver_ssl_front_end_sni_hostname(''),    setserver_ssl_front_end_sni_hostname_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServersslfrontEndsniDeleteModal row={row} loadGrid={server_ssl_front_end_sniloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServersslfrontEndsniEdit  data={server_ssl_front_end_snirowData.server_ssl_front_end_sni} setData={setDataMain} row={row} loadGrid={server_ssl_front_end_sniloadGrid} dataLoad={dataLoad} editing={true} name={"server_ssl_front_end_sni"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_ssl_front_end_sni_hostname={updateserver_ssl_front_end_sni_hostname} server_ssl_front_end_sni_hostname={server_ssl_front_end_sni_hostname}
            server_ssl_front_end_sni_hostname_valid={server_ssl_front_end_sni_hostname_valid}
            server_ssl_front_end_sni_hostname_invalid_text={server_ssl_front_end_sni_hostname_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_ssl_front_end_tlsv10} id={"server_ssl_front_end_tlsv10_id" + idPrefix}  data-tooltip-id={"server_ssl_front_end_tlsv10_tooltip_id" + idPrefix}  labelText="TLS 1.0" onChange={(evt) => { updateserver_ssl_front_end_tlsv10(evt); handleChange(); }}/>
          <ReactTooltip id={"server_ssl_front_end_tlsv10_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether or not TLS v1.0 is enabled.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_ssl_front_end_tlsv11} id={"server_ssl_front_end_tlsv11_id" + idPrefix}  data-tooltip-id={"server_ssl_front_end_tlsv11_tooltip_id" + idPrefix}  labelText="TLS 1.1" onChange={(evt) => { updateserver_ssl_front_end_tlsv11(evt); handleChange(); }}/>
          <ReactTooltip id={"server_ssl_front_end_tlsv11_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether or not TLS v1.1 is enabled.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_ssl_front_end_tlsv12} id={"server_ssl_front_end_tlsv12_id" + idPrefix}  data-tooltip-id={"server_ssl_front_end_tlsv12_tooltip_id" + idPrefix}  labelText="TLS 1.2" onChange={(evt) => { updateserver_ssl_front_end_tlsv12(evt); handleChange(); }}/>
          <ReactTooltip id={"server_ssl_front_end_tlsv12_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether or not TLS v1.2 is enabled.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_ssl_front_end_tlsv13} id={"server_ssl_front_end_tlsv13_id" + idPrefix}  data-tooltip-id={"server_ssl_front_end_tlsv13_tooltip_id" + idPrefix}  labelText="TLS 1.3" onChange={(evt) => { updateserver_ssl_front_end_tlsv13(evt); handleChange(); }}/>
          <ReactTooltip id={"server_ssl_front_end_tlsv13_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether or not TLS v1.3 is enabled.<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"server_ssl_trust_certificates_tooltip_id" + idPrefix} >Trust Certificates</h3><hr/>
</div>
          <ReactTooltip id={"server_ssl_trust_certificates_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>PEM based signer certificates or signer certificate chains which  should be added to IAG's trust store. These can be signer  certificates which are required for secure communication with  resource servers or external services.<br/></div></ReactTooltip>

                <div id={"server_ssl_trust_certificatesTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem server_div" + idPrefix}>
                    <DataTable id={"server_ssl_trust_certificatesTable" + idPrefix} isSortable
                        headers={server_ssl_trust_certificatesheaderData}
                        rows={server_ssl_trust_certificatesrowData.server_ssl_trust_certificates}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {server_ssl_trust_certificateshandleAdd(idPrefix, [setserver_ssl_trust_certificates_trust_certificates(''),    setserver_ssl_trust_certificates_trust_certificates_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServerssltrustCertificatesDeleteModal row={row} loadGrid={server_ssl_trust_certificatesloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServerssltrustCertificatesEdit  data={server_ssl_trust_certificatesrowData.server_ssl_trust_certificates} setData={setDataMain} row={row} loadGrid={server_ssl_trust_certificatesloadGrid} dataLoad={dataLoad} editing={true} name={"server_ssl_trust_certificates"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_ssl_trust_certificates_trust_certificates={updateserver_ssl_trust_certificates_trust_certificates} server_ssl_trust_certificates_trust_certificates={server_ssl_trust_certificates_trust_certificates}
            server_ssl_trust_certificates_trust_certificates_valid={server_ssl_trust_certificates_trust_certificates_valid}
            server_ssl_trust_certificates_trust_certificates_invalid_text={server_ssl_trust_certificates_trust_certificates_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"enabled_languages_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Enabled Languages Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"server_enabled_languages_tooltip_id" + idPrefix} >Enabled Languages</h3><hr/>
</div>
          <ReactTooltip id={"server_enabled_languages_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>The language(s) which will be permitted when the application gateway generates error and management response pages. The accept-language HTTP header from the request is used to determine the language used when generating responses.<br/><br/>The first language in the list will be treated as the default language. The default language will be used if none of the languages contained in the accept-language HTTP header have been enabled.<br/><br/>If this entry is not defined, all languages will be enabled with English (C) set as the default.<br/><br/><h4># language codes</h4><br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}> `language code` </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Language              </th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> pt              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Brazilian Portuguese  </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> cs              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Czech                 </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> zh_CN           </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Chinese (Simplified)  </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> zh_TW           </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Chinese (Traditional) </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> C               </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> English               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> fr              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> French                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> de              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> German                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> hu              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Hungarian             </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> it              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Italian               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ja              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Japanese              </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ko              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Korean                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> pl              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Polish                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> es              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Spanish               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ru              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Russian               </td></tr></tbody></table></div></ReactTooltip>

                <div id={"server_enabled_languagesTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem server_div" + idPrefix}>
                    <DataTable id={"server_enabled_languagesTable" + idPrefix} isSortable
                        headers={server_enabled_languagesheaderData}
                        rows={server_enabled_languagesrowData.server_enabled_languages}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {server_enabled_languageshandleAdd(idPrefix, [setserver_enabled_languages_enabled_languages(''),    setserver_enabled_languages_enabled_languages_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServerenabledLanguagesDeleteModal row={row} loadGrid={server_enabled_languagesloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServerenabledLanguagesEdit  data={server_enabled_languagesrowData.server_enabled_languages} setData={setDataMain} row={row} loadGrid={server_enabled_languagesloadGrid} dataLoad={dataLoad} editing={true} name={"server_enabled_languages"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_enabled_languages_enabled_languages={updateserver_enabled_languages_enabled_languages} server_enabled_languages_enabled_languages={server_enabled_languages_enabled_languages}
            server_enabled_languages_enabled_languages_valid={server_enabled_languages_enabled_languages_valid}
            server_enabled_languages_enabled_languages_invalid_text={server_enabled_languages_enabled_languages_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"websocket_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>WebSocket Settings</h2><hr/>
                  Specifies the configuration for WebSocket support.
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Timeouts</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Applications</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"40px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_websocket_timeouts_applications_read} id={"server_websocket_timeouts_applications_read_id" + idPrefix}  data-tooltip-id={"server_websocket_timeouts_applications_read_tooltip_id" + idPrefix}  min={1}  label="Read" onChange={(evt) => { updateserver_websocket_timeouts_applications_read(evt); handleChange(); }}/>
          <ReactTooltip id={"server_websocket_timeouts_applications_read_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum length of time (in seconds) to wait on a read operation to complete.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_websocket_timeouts_applications_write} id={"server_websocket_timeouts_applications_write_id" + idPrefix}  data-tooltip-id={"server_websocket_timeouts_applications_write_tooltip_id" + idPrefix}  min={1}  label="Write" onChange={(evt) => { updateserver_websocket_timeouts_applications_write(evt); handleChange(); }}/>
          <ReactTooltip id={"server_websocket_timeouts_applications_write_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum length of time (in seconds) to wait on a write operation to complete.<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Front End</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"40px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_websocket_timeouts_front_end_read} id={"server_websocket_timeouts_front_end_read_id" + idPrefix}  data-tooltip-id={"server_websocket_timeouts_front_end_read_tooltip_id" + idPrefix}  min={1}  label="Read" onChange={(evt) => { updateserver_websocket_timeouts_front_end_read(evt); handleChange(); }}/>
          <ReactTooltip id={"server_websocket_timeouts_front_end_read_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum length of time (in seconds) to wait on a read operation to complete.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_websocket_timeouts_front_end_write} id={"server_websocket_timeouts_front_end_write_id" + idPrefix}  data-tooltip-id={"server_websocket_timeouts_front_end_write_tooltip_id" + idPrefix}  min={1}  label="Write" onChange={(evt) => { updateserver_websocket_timeouts_front_end_write(evt); handleChange(); }}/>
          <ReactTooltip id={"server_websocket_timeouts_front_end_write_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum length of time (in seconds) to wait on a write operation to complete.<br/></div></ReactTooltip>
        </div>

                </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Worker Threads</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_websocket_worker_threads_idle} id={"server_websocket_worker_threads_idle_id" + idPrefix}  data-tooltip-id={"server_websocket_worker_threads_idle_tooltip_id" + idPrefix}  min={0}  label="Idle" onChange={(evt) => { updateserver_websocket_worker_threads_idle(evt); handleChange(); }}/>
          <ReactTooltip id={"server_websocket_worker_threads_idle_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>To avoid the overhead of starting and stopping web socket worker threads a number of threads can be left running idle. This will consume memory resources to keep them alive and idle when not in use, but will save CPU and thread start-up time when a new web socket requires threads. This option specifies the maximum count of cached idle worker threads. A value of zero will disable the caching of idle threads.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_websocket_worker_threads_max} id={"server_websocket_worker_threads_max_id" + idPrefix}  data-tooltip-id={"server_websocket_worker_threads_max_tooltip_id" + idPrefix}  min={0}  label="Max" onChange={(evt) => { updateserver_websocket_worker_threads_max(evt); handleChange(); }}/>
          <ReactTooltip id={"server_websocket_worker_threads_max_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum number of threads which will be used used to proxy WebSocket connections through the gateway. A value of zero will cause WebSockets to be blocked. Each WebSocket connection will require two worker threads. If more than the max value are in use, the daemon will immediately close the WebSocket even if the WebSocket upgrade request to the application succeeded. The WebSocket threads operate independently from the server:worker_threads entry.<br/></div></ReactTooltip>
        </div>

                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"rate_limiting_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Rate Limiting Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="Specifies the global configuration related to rate limiting">
                    <p>Specifies the global configuration related to rate limiting. Rate limiting policies are defined using the policies/rate_limiting[] entry.<br/><br/>Additional rate limiting headers can also be enabled. The rate limiting response headers include:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>header </th><th style={{borderRight:'1px solid black', padding: '10px'}}> value </th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>X-Rate-Limit-Policy    </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The name of the rate limiting policy which is closest to being hit.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>X-Rate-Limit-Remaining </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The number of requests left for the rate limiting policy in the current rate limit window.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>X-Rate-Limit-Reset     </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The time (UTC Epoch time) at which the rate limiting policy resets.</td></tr></tbody></table></p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_rate_limiting_cache_size} id={"server_rate_limiting_cache_size_id" + idPrefix}  data-tooltip-id={"server_rate_limiting_cache_size_tooltip_id" + idPrefix}  min={1}  label="Cache Size" onChange={(evt) => { updateserver_rate_limiting_cache_size(evt); handleChange(); }}/>
          <ReactTooltip id={"server_rate_limiting_cache_size_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The number of unique records to cache locally for the rate limiting capability. When this cache is exhausted, the oldest  cached records are ejected. This effectively resets the rate limiting counters for this client(s). This number needs to be  higher than the number of requests being rate limited across a  refresh interval.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Redis</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_rate_limiting_redis_collection_name}  id={"server_rate_limiting_redis_collection_name_id" + idPrefix}  data-tooltip-id={"server_rate_limiting_redis_collection_name_tooltip_id" + idPrefix}  labelText="Collection Name" onChange={(evt) => { updateserver_rate_limiting_redis_collection_name(evt); handleChange(); }}/>
          <ReactTooltip id={"server_rate_limiting_redis_collection_name_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Specify the name of a Redis collection which will be used for  maintaining rate limiting data. Redis collections are defined using the services/redis[] entry.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_rate_limiting_redis_sync_window} id={"server_rate_limiting_redis_sync_window_id" + idPrefix}  data-tooltip-id={"server_rate_limiting_redis_sync_window_tooltip_id" + idPrefix}  min={0}  label="Sync Window" onChange={(evt) => { updateserver_rate_limiting_redis_sync_window(evt); handleChange(); }}/>
          <ReactTooltip id={"server_rate_limiting_redis_sync_window_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The length of time (in seconds) a record from Redis will be  cached locally by this instance. Records will only be  synchronized with Redis after this window has elapsed.<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_rate_limiting_response_headers} id={"server_rate_limiting_response_headers_id" + idPrefix}  data-tooltip-id={"server_rate_limiting_response_headers_tooltip_id" + idPrefix}  labelText="Response Headers" onChange={(evt) => { updateserver_rate_limiting_response_headers(evt); handleChange(); }}/>
          <ReactTooltip id={"server_rate_limiting_response_headers_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Specifies whether or not the gateway will insert the rate limiting headers into responses.<br/>By default, the rate limiting response headers are disabled.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"credential_service_cache_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Credential Service Cache Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="Specifies the configuration for the credential service cache">
                    <p>Specifies the configuration for the credential service cache. When the cache is enabled, IAG will cache the encrypted credentials received from the external credential service. If the cache is not enabled, IAG will request credentials from the credential service for every request requiring single sign-on.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_credential_service_cache_cache_enabled} id={"server_credential_service_cache_cache_enabled_id" + idPrefix}  data-tooltip-id={"server_credential_service_cache_cache_enabled_tooltip_id" + idPrefix}  labelText="Cache Enabled" onChange={(evt) => { updateserver_credential_service_cache_cache_enabled(evt); handleChange(); }}/>
          <ReactTooltip id={"server_credential_service_cache_cache_enabled_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean to indicate whether the credential service cache is enabled or not.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_credential_service_cache_cache_size} id={"server_credential_service_cache_cache_size_id" + idPrefix}  data-tooltip-id={"server_credential_service_cache_cache_size_tooltip_id" + idPrefix}  min={0}  label="Cache Size" onChange={(evt) => { updateserver_credential_service_cache_cache_size(evt); handleChange(); }}/>
          <ReactTooltip id={"server_credential_service_cache_cache_size_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The cache size, the number of entries which will be cached.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_credential_service_cache_entry_idle_timeout} id={"server_credential_service_cache_entry_idle_timeout_id" + idPrefix}  data-tooltip-id={"server_credential_service_cache_entry_idle_timeout_tooltip_id" + idPrefix}  min={0}  label="Entry Idle Timeout" onChange={(evt) => { updateserver_credential_service_cache_entry_idle_timeout(evt); handleChange(); }}/>
          <ReactTooltip id={"server_credential_service_cache_entry_idle_timeout_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The entry idle timeout, the number of seconds a cache entry which is not being used will remain cached for.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_credential_service_cache_entry_lifetime} id={"server_credential_service_cache_entry_lifetime_id" + idPrefix}  data-tooltip-id={"server_credential_service_cache_entry_lifetime_tooltip_id" + idPrefix}  min={0}  label="Entry Lifetime" onChange={(evt) => { updateserver_credential_service_cache_entry_lifetime(evt); handleChange(); }}/>
          <ReactTooltip id={"server_credential_service_cache_entry_lifetime_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The entry lifetime, the maximum number of seconds entries will be cached for, regardless of whether they are being used or not.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_credential_service_cache_login_clear_user} id={"server_credential_service_cache_login_clear_user_id" + idPrefix}  data-tooltip-id={"server_credential_service_cache_login_clear_user_tooltip_id" + idPrefix}  labelText="Login Clear User" onChange={(evt) => { updateserver_credential_service_cache_login_clear_user(evt); handleChange(); }}/>
          <ReactTooltip id={"server_credential_service_cache_login_clear_user_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>If set to true, on successful authentication any existing cached credentials for the authenticating user will be cleared.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"failover_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Failover Settings</h2><hr/>
                  Specifies the configuration related to failover support for the IBM Application Gateway.
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_failover_cookie_name}  id={"server_failover_cookie_name_id" + idPrefix}  data-tooltip-id={"server_failover_cookie_name_tooltip_id" + idPrefix}  labelText="Cookie Name" onChange={(evt) => { updateserver_failover_cookie_name(evt); handleChange(); }}/>
          <ReactTooltip id={"server_failover_cookie_name_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The name of the cookie which will be used to store the failover JWE.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_failover_domain_cookie} id={"server_failover_domain_cookie_id" + idPrefix}  data-tooltip-id={"server_failover_domain_cookie_tooltip_id" + idPrefix}  labelText="Domain Cookie" onChange={(evt) => { updateserver_failover_domain_cookie(evt); handleChange(); }}/>
          <ReactTooltip id={"server_failover_domain_cookie_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean flag indicating whether or not the failover cookie should include a domain. By including a domain the failover cookie will be sent to any server within the same DNS domain. For example, a failover cookie which is generated by `server_a.ibm.com` will also be sent to `server_b.ibm.com`. The name of the domain which is used in the failover cookie is derived from the Host header in the HTTP request.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_failover_key}  id={"server_failover_key_id" + idPrefix}  data-tooltip-id={"server_failover_key_tooltip_id" + idPrefix}  labelText="Key" onChange={(evt) => { updateserver_failover_key(evt); handleChange(); }}/>
          <ReactTooltip id={"server_failover_key_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The key which is used to protect the failover JWE cookie. This key should be 512 bits in length. If the key is greater than this size it will be truncated, and if it is less than this size it will be right-padded with 0's. An example openssl command to create this key is: `openssl rand -out oct-512-bit.bin 64`<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"management_pages_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Management Pages Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="This entry overloads the server generated management response pages">
                    <p>This entry overloads the server generated management response pages.<br/>This entry must be either a zip file or a path which is relative to the `/var/iag/config` directory of the container.<br/>The provided contents will completely replace the default set of management pages served by the IAG.<br/><br/>The pages which are provided should conform to the directory structure and file name syntax explained below.<br/>The directory structure is:<br/><br/>`&lt;language_code&gt;/&lt;page_name&gt;.&lt;response_code&gt;.&lt;mime_type&gt;`<br/><br/><h4># language_code</h4><br/><br/>`&lt;language_code&gt;` is a directory containing all the pages which will be presented to clients which prefer that language.<br/>If you do not wish to ever return pages to clients in a specific language, the corresponding language_code directory can be omitted.<br/>The reverse proxy will use the container language (set via the `LANG` environment variable) if a page is requested in a language which is not provided.<br/><br/>For example, to only ever return management pages in English and French, include only the `C` and `fr` directories in the zip file and run the container with `LANG=C`.<br/>When a language other than English or French is requested, the page will fall back to `LANG` and be returned in English.<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}> `language_code` </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Language              </th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> pt              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Brazilian Portuguese  </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> cs              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Czech                 </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> zh_CN           </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Chinese (Simplified)  </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> zh_TW           </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Chinese (Traditional) </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> C               </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> English               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> fr              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> French                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> de              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> German                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> hu              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Hungarian             </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> it              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Italian               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ja              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Japanese              </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ko              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Korean                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> pl              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Polish                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> es              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Spanish               </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ru              </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Russian               </td></tr></tbody></table><br/><h4># page_name</h4><br/><br/>`&lt;page_name&gt;` corresponds to the specific event which the page is returned for.<br/>The list of valid page_names are:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}> `page_name`           </th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> help                  </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> login_success         </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> logout                </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> oidc_fragment         </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> ratelimit             </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> redirect              </td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> temp_cache_response </td></tr></tbody></table><br/><h4># response_code</h4><br/><br/>`&lt;response_code&gt;` can be used to control the HTTP status code which the reverse proxy presents when it serves the page.<br/>This part of filename is optional and 200 will be used if no response_code is indicated.<br/><br/><h4># mime_type</h4><br/><br/>`&lt;mime_type&gt;` corresponds to the mime sub-type which this page will be returned for.<br/>For example, if a client request contains the `accept` header `text/html`, `html` is the mime sub-type and should be used for the file extension.<br/>If an `accept` header is not present, the reverse proxy will also consider the `content-type` header.<br/><br/><h4># Examples</h4><br/><br/>For example, to customise:<br/><br/>- the `ratelimit` management response<br/>- for English language<br/>- to return HTTP status 500<br/>- for clients expecting `text/html`<br/><br/>Create the following file in the zip file of management response pages:<br/><br/>`C/ratelimit.500.html`<br/><br/><h4># Defaults</h4><br/><br/>If no value is specified here, the default set of pages will be used.<br/>The default set of pages, `management_pages.zip`, can be downloaded from GitHub (https://github.com/IBM-Security/ibm-application-gateway-resources/tree/master/pages) and used as a starting point for creating custom management pages.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_management_pages_content}  id={"server_management_pages_content_id" + idPrefix}  data-tooltip-id={"server_management_pages_content_tooltip_id" + idPrefix}  labelText="Content" onChange={(evt) => { updateserver_management_pages_content(evt); handleChange(); }}/>
          <ReactTooltip id={"server_management_pages_content_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The content which will be used for the management pages.  The content can either be the name of a directory, relative to the `/var/iag/config` directory of the container, or a zip file.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
                <Select
                  value={server_management_pages_type}
                   id={"server_management_pages_type_id" + idPrefix}
 data-tooltip-id={"server_management_pages_type_tooltip_id" + idPrefix}                   labelText="Type"
                  onChange={(evt) => { updateserver_management_pages_type(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="zip" value="zip" />
                  <SelectItem text="path" value="path" />
                </Select>
          <ReactTooltip id={"server_management_pages_type_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The type of content which is being supplied.  Either a zip file or a directory name.<br/></div></ReactTooltip>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"public_assets_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Public Assets Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="This entry overloads the default assets used in server generated error and management response pages">
                    <p>This entry overloads the default assets used in server generated error and management response pages.<br/>These assets are served by the application gateway on the configured path segment (default `pkmspublic`) and are suitable for embedding in server generated responses such as error or management pages.<br/><br/><br/><h4># Defaults</h4><br/><br/>If no value is specified here, the default set of assets will be used.<br/>The default set of assets, used by the default error and management pages, `public_assets.zip`, can be downloaded from GitHub (https://github.com/IBM-Security/ibm-application-gateway-resources/tree/master/pages).</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_public_assets_content}  id={"server_public_assets_content_id" + idPrefix}  data-tooltip-id={"server_public_assets_content_tooltip_id" + idPrefix}  labelText="Content" onChange={(evt) => { updateserver_public_assets_content(evt); handleChange(); }}/>
          <ReactTooltip id={"server_public_assets_content_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The content which will be used for the public assets.  The content can either be the name of a directory, relative to the `/var/iag/config` directory of the container, or a zip file.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_public_assets_path_segment}  id={"server_public_assets_path_segment_id" + idPrefix}  data-tooltip-id={"server_public_assets_path_segment_tooltip_id" + idPrefix}  labelText="Path Segment" onChange={(evt) => { updateserver_public_assets_path_segment(evt); handleChange(); }}/>
          <ReactTooltip id={"server_public_assets_path_segment_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The path which the assets will be available from. By default, this is `pkmspublic`.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
                <Select
                  value={server_public_assets_type}
                   id={"server_public_assets_type_id" + idPrefix}
 data-tooltip-id={"server_public_assets_type_tooltip_id" + idPrefix}                   labelText="Type"
                  onChange={(evt) => { updateserver_public_assets_type(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="zip" value="zip" />
                  <SelectItem text="path" value="path" />
                </Select>
          <ReactTooltip id={"server_public_assets_type_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The type of content which is being supplied.  Either a zip file or a directory name.<br/></div></ReactTooltip>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"local_pages_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Local Pages Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="Defines static assets which are served from the default `/` path of the reverse proxy">
                    <p>Defines static assets which are served from the default `/` path of the reverse proxy. This entry must be either a zip file or a path which is relative to the `/var/iag/config` directory of the container. The provided contents will completely replace the default set of pages served from the `/` path of the IAG.<br/><h4># Defaults</h4><br/>If no value is specified here, the default set of pages will be used. The default set of pages, `local_pages.zip`, can be downloaded from GitHub (https://github.com/IBM-Security/ibm-application-gateway-resources/tree/master/pages) and used as a starting point for creating custom pages.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_local_pages_content}  id={"server_local_pages_content_id" + idPrefix}  data-tooltip-id={"server_local_pages_content_tooltip_id" + idPrefix}  labelText="Content" onChange={(evt) => { updateserver_local_pages_content(evt); handleChange(); }}/>
          <ReactTooltip id={"server_local_pages_content_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The content which will be used for the local web space.  The content can either be the name of a directory, relative to the `/var/iag/config` directory of the container, or a zip file.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
                <Select
                  value={server_local_pages_type}
                   id={"server_local_pages_type_id" + idPrefix}
 data-tooltip-id={"server_local_pages_type_tooltip_id" + idPrefix}                   labelText="Type"
                  onChange={(evt) => { updateserver_local_pages_type(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="zip" value="zip" />
                  <SelectItem text="path" value="path" />
                </Select>
          <ReactTooltip id={"server_local_pages_type_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The type of content which is being supplied.  Either a zip file or a directory name.<br/></div></ReactTooltip>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"General_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>General Settings</h2><hr/>
                  Specifies the general settings associated with this component
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
                <Select
                  value={server_content_security_policy}
                   id={"server_content_security_policy_id" + idPrefix}
 data-tooltip-id={"server_content_security_policy_tooltip_id" + idPrefix}                   labelText="Content Security Policy"
                  onChange={(evt) => { updateserver_content_security_policy(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="default" value="default" />
                  <SelectItem text="disabled" value="disabled" />
                </Select>
          <ReactTooltip id={"server_content_security_policy_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>Specifies whether or not the gateway will use the default content security policy.<br/><br/>The default policy inserts the following HTTP headers into all responses:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>header </th><th style={{borderRight:'1px solid black', padding: '10px'}}> value</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>x-frame-options </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> DENY</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>x-xss-protection </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> 1</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>content-security-policy </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> default-src 'self'; frame-ancestors 'self'; form-action 'self';</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>x-content-type-options </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> nosniff</td></tr></tbody></table></div></ReactTooltip>
                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_http2} id={"server_http2_id" + idPrefix}  data-tooltip-id={"server_http2_tooltip_id" + idPrefix}  labelText="HTTP/2" onChange={(evt) => { updateserver_http2(evt); handleChange(); }}/>
          <ReactTooltip id={"server_http2_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A boolean which indicates whether or not to enable support for HTTP/2 clients. HTTP/2 supports a reduced set of cipher suites. The minimum cipher is `TLS_ECDHE_RSA_WITH_AES_128_GCM_SHA256` which should be added to the `server/ssl/ciphers[]` entry.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_worker_threads} id={"server_worker_threads_id" + idPrefix}  data-tooltip-id={"server_worker_threads_tooltip_id" + idPrefix}  min={1}  label="Worker Threads" onChange={(evt) => { updateserver_worker_threads(evt); handleChange(); }}/>
          <ReactTooltip id={"server_worker_threads_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The number of configured worker threads specifies the number of concurrent incoming requests that can be serviced by this gateway instance. Choosing the optimal number depends on the quantity and type of traffic on your network. Modifying this value should be done carefully to ensure optimal performance.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"client_ip_rules_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Client IP Rules Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"server_client_ip_rules_tooltip_id" + idPrefix} >Client IP Rules</h3><hr/>
</div>
          <ReactTooltip id={"server_client_ip_rules_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>The rules which define whether a client is allowed to connect to this server. The rule is of the format:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>`[+</th><th style={{borderRight:'1px solid black', padding: '10px'}}>-]&lt;client-ip&gt;`</th></tr></tbody></table><br/>where:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>Element           </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Description</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>+                 </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Indicates that the client is permitted access.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>-                 </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Indicates that the client is not permitted access.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>&lt;client-ip&gt; </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The IP address of the client, which can also contain the pattern matching characters `*` and `?`.</td></tr></tbody></table><br/>The client IP address of a request will be evaluated against each rule in sequence until a match is found.  The corresponding code (+|-) will then be used to determine whether the client connection is accepted.  If the client IP matches no configured rules the client connection will be accepted.<br/></div></ReactTooltip>

                <div id={"server_client_ip_rulesTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem server_div" + idPrefix}>
                    <DataTable id={"server_client_ip_rulesTable" + idPrefix} isSortable
                        headers={server_client_ip_rulesheaderData}
                        rows={server_client_ip_rulesrowData.server_client_ip_rules}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {server_client_ip_ruleshandleAdd(idPrefix, [setserver_client_ip_rules_client_ip_rules(''),    setserver_client_ip_rules_client_ip_rules_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <ServerclientIpRulesDeleteModal row={row} loadGrid={server_client_ip_rulesloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <ServerclientIpRulesEdit  data={server_client_ip_rulesrowData.server_client_ip_rules} setData={setDataMain} row={row} loadGrid={server_client_ip_rulesloadGrid} dataLoad={dataLoad} editing={true} name={"server_client_ip_rules"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_client_ip_rules_client_ip_rules={updateserver_client_ip_rules_client_ip_rules} server_client_ip_rules_client_ip_rules={server_client_ip_rules_client_ip_rules}
            server_client_ip_rules_client_ip_rules_valid={server_client_ip_rules_client_ip_rules_valid}
            server_client_ip_rules_client_ip_rules_invalid_text={server_client_ip_rules_client_ip_rules_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"session_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading server_div" + idPrefix}>
                  <span className="iag_breadcrumb">Server : </span><br/>                  <h2>Session Settings</h2><hr/>
                  Specifies the configuration for client sessions.
                </div>
                <div className={"iag--simple-div server_div" + idPrefix}>
                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_session_cookie_name}  id={"server_session_cookie_name_id" + idPrefix}  data-tooltip-id={"server_session_cookie_name_tooltip_id" + idPrefix}  labelText="Cookie Name" onChange={(evt) => { updateserver_session_cookie_name(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_cookie_name_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The name of the session cookie presented to clients.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_session_inactive_timeout} id={"server_session_inactive_timeout_id" + idPrefix}  data-tooltip-id={"server_session_inactive_timeout_tooltip_id" + idPrefix}  min={0}  label="Inactive Timeout" onChange={(evt) => { updateserver_session_inactive_timeout(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_inactive_timeout_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum lifetime (in seconds) a session can remain inactive before it is expired. If set to `0` the sessions will not have a maximum inactive lifetime.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_session_max_sessions} id={"server_session_max_sessions_id" + idPrefix}  data-tooltip-id={"server_session_max_sessions_tooltip_id" + idPrefix}  min={1}  label="Max Sessions" onChange={(evt) => { updateserver_session_max_sessions(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_max_sessions_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum number of concurrent sessions.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_session_permit_user_switching} id={"server_session_permit_user_switching_id" + idPrefix}  data-tooltip-id={"server_session_permit_user_switching_tooltip_id" + idPrefix}  labelText="Permit User Switching" onChange={(evt) => { updateserver_session_permit_user_switching(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_permit_user_switching_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>During an obligated re-authentication, depending on the policy and identity provider a different user credential may be returned to the application gateway. By default, the application gateway will not accept a credential if the user name does not match the user which the session was originally established for. Use this entry to change the behaviour and allow the application gateway to accept a credential containing a different user name during re-authentication.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Reauth</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_session_reauth_login_time_window} id={"server_session_reauth_login_time_window_id" + idPrefix}  data-tooltip-id={"server_session_reauth_login_time_window_tooltip_id" + idPrefix}  min={0}  label="Login Time Window" onChange={(evt) => { updateserver_session_reauth_login_time_window(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_reauth_login_time_window_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Controls the amount of time a re-authentication will be  considered valid for. This is a time (in seconds) after a re-authentication occurs during which a client will not be prompted to perform re-authentication again.<br/>By default, the login_time_window is set to zero, which means that every request to a resource protected with the reauth  policy directive will require the client to perform  re-authentication.<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Redis</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"20px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_session_redis_client_list_cache_lifetime} id={"server_session_redis_client_list_cache_lifetime_id" + idPrefix}  data-tooltip-id={"server_session_redis_client_list_cache_lifetime_tooltip_id" + idPrefix}  min={0}  label="Client List Cache Lifetime" onChange={(evt) => { updateserver_session_redis_client_list_cache_lifetime(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_redis_client_list_cache_lifetime_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>The server needs to manually delete stale entries from the Redis cache during session creation and idle timeout events.  In order to be able to delete the stale entries it needs an up-to-date list of active clients of the Redis server (using the `CLIENT LIST` Redis command).  This command, depending on the number of clients which are registered with the Redis server, can be expensive and so IAG will cache and reuse the returned list of clients for a small period of time.  This configuration entry controls the length of time, in seconds, that a client list will be cached.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
  <h3>Concurrent Sessions</h3><hr/>
</div>
                <div className="iag-wdgt-container" style={{marginLeft:"40px",marginBottom:"10px"}}>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_session_redis_concurrent_sessions_enabled} id={"server_session_redis_concurrent_sessions_enabled_id" + idPrefix}  data-tooltip-id={"server_session_redis_concurrent_sessions_enabled_tooltip_id" + idPrefix}  labelText="Enabled" onChange={(evt) => { updateserver_session_redis_concurrent_sessions_enabled(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_redis_concurrent_sessions_enabled_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Is concurrent user session tracking and management enabled?<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_session_redis_concurrent_sessions_max_user_sessions} id={"server_session_redis_concurrent_sessions_max_user_sessions_id" + idPrefix}  data-tooltip-id={"server_session_redis_concurrent_sessions_max_user_sessions_tooltip_id" + idPrefix}  min={-1}  label="Max User Sessions" onChange={(evt) => { updateserver_session_redis_concurrent_sessions_max_user_sessions(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_redis_concurrent_sessions_max_user_sessions_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum number of concurrent sessions which are allowed for a single user.  A value of `0` indicates that an unlimited number of sessions are allowed, and a value of `-1` indicates that only a single session is allowed for the user and that any existing sessions will be displaced by the new session.  The maximum number of user sessions for a particular session can also be defined using the `tagvalue_max_concurrent_web_sessions` attribute of the credential.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_session_redis_concurrent_sessions_prompt_for_displacement} id={"server_session_redis_concurrent_sessions_prompt_for_displacement_id" + idPrefix}  data-tooltip-id={"server_session_redis_concurrent_sessions_prompt_for_displacement_tooltip_id" + idPrefix}  labelText="Prompt For Displacement" onChange={(evt) => { updateserver_session_redis_concurrent_sessions_prompt_for_displacement(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_redis_concurrent_sessions_prompt_for_displacement_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>If enabled the gateway will prompt users before automatically displacing existing sessions with the same user identity.  If disabled the gateway will automatically log out the existing user session.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <TextInput  value={server_session_redis_concurrent_sessions_user_identity_attribute_name}  id={"server_session_redis_concurrent_sessions_user_identity_attribute_name_id" + idPrefix}  data-tooltip-id={"server_session_redis_concurrent_sessions_user_identity_attribute_name_tooltip_id" + idPrefix}  labelText="User Identity Attribute Name" onChange={(evt) => { updateserver_session_redis_concurrent_sessions_user_identity_attribute_name(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_redis_concurrent_sessions_user_identity_attribute_name_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The name of the credential attribute which holds the unique user identity for the session.  If the configured attribute does not exist in the credential the default user identity of `unknown` will be used.<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <Checkbox checked={server_session_redis_enabled} id={"server_session_redis_enabled_id" + idPrefix}  data-tooltip-id={"server_session_redis_enabled_tooltip_id" + idPrefix}  labelText="Enabled" onChange={(evt) => { updateserver_session_redis_enabled(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_redis_enabled_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Enables the Redis session cache.<br/></div></ReactTooltip>
        </div>

                </div>

                <div className= {"iag_form_elem server_div" + idPrefix}>
          <NumberInput value={server_session_timeout} id={"server_session_timeout_id" + idPrefix}  data-tooltip-id={"server_session_timeout_tooltip_id" + idPrefix}  min={0}  label="Timeout" onChange={(evt) => { updateserver_session_timeout(evt); handleChange(); }}/>
          <ReactTooltip id={"server_session_timeout_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The maximum lifetime (in seconds) for a session. If set to `0` the sessions will not have a maximum lifetime, however once `max_sessions` is reached sessions will be reaped using a least recently used algorithm.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
            </Tabs>
                  <Suspense fallback={<div></div>}>
                    <ServerclientIpRulesAdd loadGrid={server_client_ip_rulesloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateserver_client_ip_rules_client_ip_rules={updateserver_client_ip_rules_client_ip_rules} server_client_ip_rules_client_ip_rules={server_client_ip_rules_client_ip_rules}
            server_client_ip_rules_client_ip_rules_valid={server_client_ip_rules_client_ip_rules_valid}
            server_client_ip_rules_client_ip_rules_invalid_text={server_client_ip_rules_client_ip_rules_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerclientIpRulesEdit  loadGrid={server_client_ip_rulesloadGrid} dataLoad={dataLoad} name={"server_client_ip_rules"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_client_ip_rules_client_ip_rules={updateserver_client_ip_rules_client_ip_rules} server_client_ip_rules_client_ip_rules={server_client_ip_rules_client_ip_rules}
            server_client_ip_rules_client_ip_rules_valid={server_client_ip_rules_client_ip_rules_valid}
            server_client_ip_rules_client_ip_rules_invalid_text={server_client_ip_rules_client_ip_rules_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerenabledLanguagesAdd loadGrid={server_enabled_languagesloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateserver_enabled_languages_enabled_languages={updateserver_enabled_languages_enabled_languages} server_enabled_languages_enabled_languages={server_enabled_languages_enabled_languages}
            server_enabled_languages_enabled_languages_valid={server_enabled_languages_enabled_languages_valid}
            server_enabled_languages_enabled_languages_invalid_text={server_enabled_languages_enabled_languages_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerenabledLanguagesEdit  loadGrid={server_enabled_languagesloadGrid} dataLoad={dataLoad} name={"server_enabled_languages"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_enabled_languages_enabled_languages={updateserver_enabled_languages_enabled_languages} server_enabled_languages_enabled_languages={server_enabled_languages_enabled_languages}
            server_enabled_languages_enabled_languages_valid={server_enabled_languages_enabled_languages_valid}
            server_enabled_languages_enabled_languages_invalid_text={server_enabled_languages_enabled_languages_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerlocalApplicationscredViewerattributesAdd loadGrid={server_local_applications_cred_viewer_attributesloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateserver_local_applications_cred_viewer_attributes_attributes={updateserver_local_applications_cred_viewer_attributes_attributes} server_local_applications_cred_viewer_attributes_attributes={server_local_applications_cred_viewer_attributes_attributes}
            server_local_applications_cred_viewer_attributes_attributes_valid={server_local_applications_cred_viewer_attributes_attributes_valid}
            server_local_applications_cred_viewer_attributes_attributes_invalid_text={server_local_applications_cred_viewer_attributes_attributes_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerlocalApplicationscredViewerattributesEdit  loadGrid={server_local_applications_cred_viewer_attributesloadGrid} dataLoad={dataLoad} name={"server_local_applications_cred_viewer_attributes"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_local_applications_cred_viewer_attributes_attributes={updateserver_local_applications_cred_viewer_attributes_attributes} server_local_applications_cred_viewer_attributes_attributes={server_local_applications_cred_viewer_attributes_attributes}
            server_local_applications_cred_viewer_attributes_attributes_valid={server_local_applications_cred_viewer_attributes_attributes_valid}
            server_local_applications_cred_viewer_attributes_attributes_invalid_text={server_local_applications_cred_viewer_attributes_attributes_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerprotocolsAdd loadGrid={server_protocolsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateserver_protocols_protocols={updateserver_protocols_protocols} server_protocols_protocols={server_protocols_protocols}
            server_protocols_protocols_valid={server_protocols_protocols_valid}
            server_protocols_protocols_invalid_text={server_protocols_protocols_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerprotocolsEdit  loadGrid={server_protocolsloadGrid} dataLoad={dataLoad} name={"server_protocols"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_protocols_protocols={updateserver_protocols_protocols} server_protocols_protocols={server_protocols_protocols}
            server_protocols_protocols_valid={server_protocols_protocols_valid}
            server_protocols_protocols_invalid_text={server_protocols_protocols_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerresponseHeadersAdd loadGrid={server_response_headersloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateserver_response_headers_attribute={updateserver_response_headers_attribute} server_response_headers_attribute={server_response_headers_attribute}
            updateserver_response_headers_header={updateserver_response_headers_header} server_response_headers_header={server_response_headers_header}
            server_response_headers_header_valid={server_response_headers_header_valid}
            server_response_headers_header_invalid_text={server_response_headers_header_invalid_text}
            updateserver_response_headers_macro={updateserver_response_headers_macro} server_response_headers_macro={server_response_headers_macro}
            updateserver_response_headers_text={updateserver_response_headers_text} server_response_headers_text={server_response_headers_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerresponseHeadersEdit  loadGrid={server_response_headersloadGrid} dataLoad={dataLoad} name={"server_response_headers"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_response_headers_attribute={updateserver_response_headers_attribute} server_response_headers_attribute={server_response_headers_attribute}
            updateserver_response_headers_header={updateserver_response_headers_header} server_response_headers_header={server_response_headers_header}
            server_response_headers_header_valid={server_response_headers_header_valid}
            server_response_headers_header_invalid_text={server_response_headers_header_invalid_text}
            updateserver_response_headers_macro={updateserver_response_headers_macro} server_response_headers_macro={server_response_headers_macro}
            updateserver_response_headers_text={updateserver_response_headers_text} server_response_headers_text={server_response_headers_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServersslciphersAdd loadGrid={server_ssl_ciphersloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateserver_ssl_ciphers_ciphers={updateserver_ssl_ciphers_ciphers} server_ssl_ciphers_ciphers={server_ssl_ciphers_ciphers}
            server_ssl_ciphers_ciphers_valid={server_ssl_ciphers_ciphers_valid}
            server_ssl_ciphers_ciphers_invalid_text={server_ssl_ciphers_ciphers_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServersslciphersEdit  loadGrid={server_ssl_ciphersloadGrid} dataLoad={dataLoad} name={"server_ssl_ciphers"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_ssl_ciphers_ciphers={updateserver_ssl_ciphers_ciphers} server_ssl_ciphers_ciphers={server_ssl_ciphers_ciphers}
            server_ssl_ciphers_ciphers_valid={server_ssl_ciphers_ciphers_valid}
            server_ssl_ciphers_ciphers_invalid_text={server_ssl_ciphers_ciphers_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServersslfrontEndcertificateAdd loadGrid={server_ssl_front_end_certificateloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateserver_ssl_front_end_certificate_certificate={updateserver_ssl_front_end_certificate_certificate} server_ssl_front_end_certificate_certificate={server_ssl_front_end_certificate_certificate}
            server_ssl_front_end_certificate_certificate_valid={server_ssl_front_end_certificate_certificate_valid}
            server_ssl_front_end_certificate_certificate_invalid_text={server_ssl_front_end_certificate_certificate_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServersslfrontEndcertificateEdit  loadGrid={server_ssl_front_end_certificateloadGrid} dataLoad={dataLoad} name={"server_ssl_front_end_certificate"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_ssl_front_end_certificate_certificate={updateserver_ssl_front_end_certificate_certificate} server_ssl_front_end_certificate_certificate={server_ssl_front_end_certificate_certificate}
            server_ssl_front_end_certificate_certificate_valid={server_ssl_front_end_certificate_certificate_valid}
            server_ssl_front_end_certificate_certificate_invalid_text={server_ssl_front_end_certificate_certificate_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServersslfrontEndsniAdd loadGrid={server_ssl_front_end_sniloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateserver_ssl_front_end_sni_hostname={updateserver_ssl_front_end_sni_hostname} server_ssl_front_end_sni_hostname={server_ssl_front_end_sni_hostname}
            server_ssl_front_end_sni_hostname_valid={server_ssl_front_end_sni_hostname_valid}
            server_ssl_front_end_sni_hostname_invalid_text={server_ssl_front_end_sni_hostname_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServersslfrontEndsniEdit  loadGrid={server_ssl_front_end_sniloadGrid} dataLoad={dataLoad} name={"server_ssl_front_end_sni"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_ssl_front_end_sni_hostname={updateserver_ssl_front_end_sni_hostname} server_ssl_front_end_sni_hostname={server_ssl_front_end_sni_hostname}
            server_ssl_front_end_sni_hostname_valid={server_ssl_front_end_sni_hostname_valid}
            server_ssl_front_end_sni_hostname_invalid_text={server_ssl_front_end_sni_hostname_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerssltrustCertificatesAdd loadGrid={server_ssl_trust_certificatesloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateserver_ssl_trust_certificates_trust_certificates={updateserver_ssl_trust_certificates_trust_certificates} server_ssl_trust_certificates_trust_certificates={server_ssl_trust_certificates_trust_certificates}
            server_ssl_trust_certificates_trust_certificates_valid={server_ssl_trust_certificates_trust_certificates_valid}
            server_ssl_trust_certificates_trust_certificates_invalid_text={server_ssl_trust_certificates_trust_certificates_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <ServerssltrustCertificatesEdit  loadGrid={server_ssl_trust_certificatesloadGrid} dataLoad={dataLoad} name={"server_ssl_trust_certificates"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateserver_ssl_trust_certificates_trust_certificates={updateserver_ssl_trust_certificates_trust_certificates} server_ssl_trust_certificates_trust_certificates={server_ssl_trust_certificates_trust_certificates}
            server_ssl_trust_certificates_trust_certificates_valid={server_ssl_trust_certificates_trust_certificates_valid}
            server_ssl_trust_certificates_trust_certificates_invalid_text={server_ssl_trust_certificates_trust_certificates_invalid_text}
                    />
                  </Suspense>
              </div>
            </div>
          </div>
        </div>
    );
};
export default ServerPage;
